{
  "addons.addonList": "Lista dodatków",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Utwórz klucz API z podanego linku",
  "addons.ambientWeatherDescription": "Stacje pogodowe (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "Klucz API",
  "addons.applicationKey": "Klucz Aplikacji",
  "addons.connect": "Podłącz",
  "addons.davisApiSecret": "API Secret",
  "addons.davisApiV2Key": "Klucz API V2",
  "addons.davisDescription": "Stacje pogodowe Davisa (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Odzyskaj klucze interfejsu API wersji 2, korzystając z tego łącza",
  "addons.disconnect": "Rozłącz",
  "addons.ecowittCreateAndRetrieveKeys": "Utwórz i pobierz swój klucz API i klucz aplikacji, korzystając z tego łącza",
  "addons.ecowittDescription": "Ecowitt zapewnia profesjonalną stację pogodową Wi-Fi, bezprzewodowe wewnętrzne termometry zewnętrzne, monitory wilgotności, precyzyjne mierniki deszczu, monitory jakości powietrza i wiele innych.",
  "addons.helpLink": "Jak połączyć {provider}",
  "addons.myAcuriteAccountOnHold": "Twoje konto zostało zawieszone. Wprowadź hasło, aby ponownie połączyć swoje konto",
  "addons.myAcuriteDescription": "AcuRite to marka stacji pogodowych nr 1 w Ameryce Północnej. Jako lider w technologii pomiaru czasu, temperatury i pogody, AcuRite dostarcza szczegółowych informacji o środowisku wewnętrznym i zewnętrznym, dzięki czemu możesz bezpiecznie zaplanować swój dzień.",
  "addons.myAcuriteEnterCredentials": "Wprowadź swoje dane uwierzytelniające My AcuRite, aby połączyć swoje konto My AcuRite ze SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Użyj swojego termostatu Netatmo, aby zmienić temperaturę w domu, z łóżka lub z drugiego końca świata.",
  "addons.netatmoThermostat": "Netatmo Thermostat",
  "addons.netatmoWeather": "Pogoda Netatmo",
  "addons.netatmoWeatherDescription": "Własne pomiary klimatu w smartfonie.",
  "addons.or": "lub",
  "addons.providerAccountDisconnected": "Połączenie z usługą pogodową wygasło. Połącz się ponownie, aby wznowić aktualizacje danych.",
  "addons.reconnect": "Połącz ponownie",
  "addons.weatherflowCreateToken": "Utwórz token z podanego linku",
  "addons.weatherflowTempestDescription": "Stacja pogodowa Tempest opracowana przez firmę Weatherflow",
  "addons.wundergroundApiKey": "Klucz API",
  "addons.wundergroundDescription": "Weather Underground to globalna społeczność ludzi łącząca dane z czujników środowiskowych, takich jak stacje pogodowe i monitory jakości powietrza, dzięki czemu możemy dostarczać bogate, hiperlokalne dane, których potrzebujesz do realizacji swoich pasji",
  "addons.wundergroundRetrieveApiKey": "Odzyskaj swój klucz API z tego łącza",
  "addons.wundergroundRetrieveStationId": "Pobierz identyfikator stacji (ID) z tego łącza",
  "addons.wundergroundStationId": "ID Stacji",
  "airQuality.adviceActivityGood": "Idealny dzień na aktywność na zewnątrz",
  "airQuality.adviceActivityHazardous": "Unikaj wszelkiej aktywności fizycznej na zewnątrz",
  "airQuality.adviceActivityLabel": "Aktywność fizyczna",
  "airQuality.adviceActivityModerate": "Dobry dzień na aktywność na zewnątrz",
  "airQuality.adviceActivitySensitive": "Rozważ krótszą i mniej intensywną aktywność na zewnątrz",
  "airQuality.adviceActivityUnhealthy": "Ogranicz długie lub intensywne aktywności i rób więcej przerw",
  "airQuality.adviceActivityVeryUnhealthy": "Unikaj długich lub intensywnych aktywności; rozważ przeniesienie ich do pomieszczeń",
  "airQuality.adviceGroupsGood": "Nie są potrzebne szczególne środki ostrożności",
  "airQuality.adviceGroupsHazardous": "Zostań w pomieszczeniu i ogranicz aktywność",
  "airQuality.adviceGroupsLabel": "Grupy wrażliwe",
  "airQuality.adviceGroupsModerate": "Osoby szczególnie wrażliwe: krótsza i mniej intensywna aktywność",
  "airQuality.adviceGroupsSensitive": "Krótsza i mniej intensywna aktywność na zewnątrz oraz więcej przerw",
  "airQuality.adviceGroupsUnhealthy": "Unikaj długich lub intensywnych aktywności na zewnątrz; rozważ przeniesienie ich do pomieszczeń",
  "airQuality.adviceGroupsVeryUnhealthy": "Unikaj wszelkiej aktywności fizycznej na zewnątrz; przełóż ją lub przenieś do pomieszczenia",
  "airQuality.adviceTimingLabel": "Kiedy wyjść",
  "airQuality.adviceTimingMorning": "Najlepiej rano — wtedy poziom ozonu jest niższy",
  "airQuality.airQuality": "Jakość powietrza",
  "airQuality.airQualityIndex": "Indeksu Jakości Powietrza",
  "airQuality.aqiForecast": "Prognoza jakości powietrza",
  "airQuality.co": "Tlenek węgla",
  "airQuality.dailyForecast": "Pogoda dzienna",
  "airQuality.details": "Szczegóły",
  "airQuality.dominantPollutant": "Dominujące zanieczyszczenie",
  "airQuality.expectedPeak": "Oczekiwany szczyt",
  "airQuality.good": "Dobra",
  "airQuality.goodDescription": "Jakość powietrza jest uznawana za zadowalającą, a zanieczyszczenie powietrza stanowi niewielkie ryzyko lub jego brak.",
  "airQuality.hazardous": "Zagrożenie dla życia",
  "airQuality.hazardousDescription": "Alarm Zdrowotny: każdy może doświadczyć poważniejszych skutków zdrowotnych.",
  "airQuality.indoorAirQuality": "Jakość powietrza wewnątrz",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Średnia",
  "airQuality.moderateDescription": "Jakość powietrza jest dopuszczalna; jednak niektóre zanieczyszczenia mogą być umiarkowanie szkodliwe dla bardzo małej liczby osób, które są niezwykle wrażliwe na zanieczyszczenie powietrza.",
  "airQuality.no2": "Tlenek Azotu",
  "airQuality.noForecastForLocation": "Brak dostępnej prognozy jakości powietrza dla tej lokalizacji.",
  "airQuality.now": "Teraz",
  "airQuality.o3": "Ozon",
  "airQuality.pm10": "Cząstki stałe 10 μm lub mniej",
  "airQuality.pm25": "Cząstki stałe 2.5 μm lub mniej",
  "airQuality.pollutants": "Zanieczyszczenia",
  "airQuality.ppb": "ppb",
  "airQuality.recommendations": "Zalecenia",
  "airQuality.sensitiveUnhealthy": "Niezdrowa dla osób wrażliwych",
  "airQuality.sensitiveUnhealthyDescription": "U osób wrażliwych mogą wystąpić negatywne skutki dla zdrowia. Większość populacji może nie odczuwać negatywnych objawów.",
  "airQuality.so2": "Dwutlenek siarki",
  "airQuality.subIndex": "Podindeks AQI",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Zrozumieć indeks",
  "airQuality.unhealthy": "Niezdrowa",
  "airQuality.unhealthyDescription": "Każdy może zacząć doświadczać negatywnych skutków zdrowotnych; U osób wrażliwych mogą wystąpić poważniejsze skutki zdrowotne.",
  "airQuality.veryUnhealthy": "Bardzo niezdrowa",
  "airQuality.veryUnhealthyDezscription": "Ostrzeżenie zdrowotne, poziom alarmowy. Bardzo prawdopodobny negatywny wpływ na całą populację.",
  "alerts.addAlert": "Dodaj alert",
  "alerts.addCondition": "Dodaj warunek",
  "alerts.alertAdded": "Alarm poprawnie dodany",
  "alerts.alertAuthorizationNotice": "Alarmy działają tylko jeśli SmartMixin ma pozwolenie do wyświetlania powiadomień",
  "alerts.alertDeleted": "Alarm poprawnie usunięty",
  "alerts.alertEdited": "Alarm poprawnie zmodyfikowany",
  "alerts.alertName": "Nazwa alarmu",
  "alerts.alertWhen": "Chce być ostrzegany kiedy:",
  "alerts.aqiGreaterThan": "AQI większe niż",
  "alerts.aqiGreaterThanThreshold": "AQI większe niż {value}{unit}",
  "alerts.aqiLessThan": "AQI mniejsze niż",
  "alerts.aqiLessThanThreshold": "AQI mniejsze niż {value}{unit}",
  "alerts.atLeastOneCondition": "Musisz dodać co najmniej jeden warunek",
  "alerts.co2GreaterThan": "CO2 większe niż",
  "alerts.co2GreaterThanThreshold": "CO2 większe niż {value}{unit}",
  "alerts.co2LessThan": "CO2 mniejsze niż",
  "alerts.co2LessThanThreshold": "CO2 mniejsze niż {value}{unit}",
  "alerts.conditions": "Warunki",
  "alerts.createAlert": "Utwórz alarm",
  "alerts.dailyPrecipitationGreaterThan": "Opady dobowe większe niż",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Opady dobowe przekraczające próg {value}{unit}",
  "alerts.deleteAlert": "Usuń alarm",
  "alerts.editAlert": "Edytuj alarm",
  "alerts.editCondition": "Edytuj warunek",
  "alerts.gustSpeedGreaterThan": "Podmuch wiatru większy niż",
  "alerts.gustSpeedGreaterThanThreshold": "Porywy wiatru większe niż {value}{unit}",
  "alerts.gustSpeedLessThan": "Porywy wiatru mniejsze niż",
  "alerts.gustSpeedLessThanThreshold": "Porywy wiatru mniejsze niż {value}{unit}",
  "alerts.heatIndexGreaterThan": "Indeks ciepła większy niż",
  "alerts.heatIndexGreaterThanThreshold": "Indeks ciepła większy niż {value}{unit}",
  "alerts.heatIndexLessThan": "Indeks ciepła mniejszy niż",
  "alerts.heatIndexLessThanThreshold": "Indeks ciepła mniejszy niż {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex większy niż",
  "alerts.humidexGreaterThanThreshold": "Humidex większy niż {value}{unit}",
  "alerts.humidexLessThan": "Humidex mniejszy niż",
  "alerts.humidexLessThanThreshold": "Humidex mniejszy niż {value}{unit}",
  "alerts.humidityGreaterThan": "Wilgotność większa niż",
  "alerts.humidityGreaterThanThreshold": "Wilgotność większa niż {value}{unit}",
  "alerts.humidityLessThan": "Wilgotność mniejsza niż",
  "alerts.humidityLessThanThreshold": "Wilgotność mniejsza niż {value}{unit}",
  "alerts.inProgress": "W trakcie",
  "alerts.myAlerts": "Moje alarmy",
  "alerts.noConfiguredAlert": "Nie masz skonfigurowanego żadnego alarmu, dodaj jakiś",
  "alerts.noiseGreaterThan": "Hałas większy niż",
  "alerts.noiseGreaterThanThreshold": "Hałas większy niż {value}{unit}",
  "alerts.noiseLessThan": "Hałas mniejszy niż",
  "alerts.noiseLessThanThreshold": "Hałas mniejszy niż {value}{unit}",
  "alerts.noteOnConditions": "Pamiętaj, że alert jest wyzwalany, gdy wszystkie poniższe warunki zostaną zweryfikowane",
  "alerts.noTriggerHistory": "Ten alert nie został jeszcze wyzwolony.",
  "alerts.pm10GreaterThan": "PM10 większe niż",
  "alerts.pm10GreaterThanThreshold": "PM10 większe niż {value}{unit}",
  "alerts.pm10LessThan": "PM10 mniejsze niż",
  "alerts.pm10LessThanThreshold": "PM10 mniejsze niż {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 większe niż",
  "alerts.pm1GreaterThanThreshold": "PM 1 większe niż {value}{unit}",
  "alerts.pm1LessThan": "PM 1 mniejsze niż",
  "alerts.pm1LessThanThreshold": "PM 1 mniejsze niż {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 większe niż",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 większe niż {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 mniejsze niż",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 mniejsze niż {value}{unit}",
  "alerts.postStormSummary": "Podsumowanie opadów",
  "alerts.postStormSynopsisHelper": "Otrzymasz powiadomienie z podsumowaniem po zakończeniu każdych opadów.",
  "alerts.postStormSynopsisSoleCondition": "Podsumowania po burzy nie można łączyć z innymi warunkami.",
  "alerts.precipitationGreaterThan": "Opady godzinowe większe niż",
  "alerts.precipitationGreaterThanThreshold": "Opady godzinowe przekraczające próg {value}{unit}",
  "alerts.pressureGreaterThan": "Ciśnienie większe niż",
  "alerts.pressureGreaterThanThreshold": "Ciśnienie większe niż {value}{unit}",
  "alerts.pressureLessThan": "Ciśnienie mniejsze niż",
  "alerts.pressureLessThanThreshold": "Ciśnienie mniejsze niż {value}{unit}",
  "alerts.rainRateGreaterThan": "Natężenie deszczu większe niż",
  "alerts.rainRateGreaterThanThreshold": "Natężenie deszczu przekraczające próg {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Nasłonecznienie większe niż",
  "alerts.solarRadiationGreaterThanThreshold": "Nasłonecznienie większe niż {value}{unit}",
  "alerts.solarRadiationLessThan": "Nasłonecznienie mniejsze niż",
  "alerts.solarRadiationLessThanThreshold": "Nasłonecznienie mniejsze niż {value}{unit}",
  "alerts.stormChartUnavailable": "Historia deszczu dla tych opadów jest niedostępna.",
  "alerts.stormDetail": "Podsumowanie opadów",
  "alerts.stormDuration": "Czas trwania",
  "alerts.stormEnd": "Koniec",
  "alerts.stormPeakRate": "Maksymalne natężenie deszczu",
  "alerts.stormStart": "Początek",
  "alerts.stormTotal": "Suma opadów",
  "alerts.temperatureGreaterThan": "Temperatura większa niż",
  "alerts.temperatureGreaterThanThreshold": "Temperatura większa niż {value}{unit}",
  "alerts.temperatureLessThan": "Temperatura mniejsza niż",
  "alerts.temperatureLessThanThreshold": "Temperatura mniejsza niż {value}{unit}",
  "alerts.thswGreaterThan": "THSW większy niż",
  "alerts.thswGreaterThanThreshold": "THSW większy niż {value}{unit}",
  "alerts.thswLessThan": "THSW mniejszy niż",
  "alerts.thswLessThanThreshold": "THSW mniejszy niż {value}{unit}",
  "alerts.thwGreaterThan": "THW większy niż",
  "alerts.thwGreaterThanThreshold": "THW większy niż {value}{unit}",
  "alerts.thwLessThan": "THW mniejszy niż",
  "alerts.thwLessThanThreshold": "THW mniejszy niż {value}{unit}",
  "alerts.triggerHistory": "Historia alertu",
  "alerts.uvGreaterThan": "UV Index większy niż",
  "alerts.uvGreaterThanThreshold": "UV Index większy niż {value}{unit}",
  "alerts.uvLessThan": "UV Index mniejszy niż",
  "alerts.uvLessThanThreshold": "UV Index mniejszy niż {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Widoczność większa niż {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Widoczność mniejsza niż {value}{unit}",
  "alerts.visiblityGreaterThan": "Widoczność większa niż",
  "alerts.visiblityLessThan": "Widoczność mniejsza niż",
  "alerts.whichMeasure": "O jakiej wielkości mierzonej chcesz być ostrzegany?",
  "alerts.whichModule": "Do którego modułu chciałbyś zostać powiadomiony?",
  "alerts.windChillGreaterThan": "Chłód wiatru większy niż",
  "alerts.windChillGreaterThanThreshold": "Chłód wiatru większy niż {value}{unit}",
  "alerts.windChillLessThan": "Chłód wiatru mniejszy niż",
  "alerts.windChillLessThanThreshold": "Chłód wiatru mniejszy niż {value}{unit}",
  "alerts.windSpeedGreaterThan": "Prędkość wiatru większa niż",
  "alerts.windSpeedGreaterThanThreshold": "Prędkość wiatru większa niż {value}{unit}",
  "alerts.windSpeedLessThan": "Prędkość wiatru mniejsza niż",
  "alerts.windSpeedLessThanThreshold": "Prędkość wiatru mniejsza niż {value}{unit}",
  "astral.aboveHorizonAllDay": "Cały dzień nad horyzontem",
  "astral.aboveTheHorizon": "nad horyzontem",
  "astral.apparentSize": "Rozmiar kątowy",
  "astral.astronomicalDawn": "Świt astronomiczny",
  "astral.astronomicalDusk": "Zmierzch astronomiczny",
  "astral.astronomicalSunPhase": "Astronomiczna {sunPhase}",
  "astral.belowHorizonAllDay": "Cały dzień pod horyzontem",
  "astral.belowHorizonSince": "Pod horyzontem od {time}",
  "astral.brightAllNight": "Jasno przez całą noc — nigdy całkiem ciemno",
  "astral.brightestMoment": "Najjaśniejszy moment",
  "astral.civilDawn": "Świt cywilny",
  "astral.civilDusk": "Zmierzch cywilny",
  "astral.civilSunPhase": "{sunPhase} cywilny",
  "astral.darkSkyWindow": "Ciemne niebo {from} → {to} · {duration} bez Księżyca",
  "astral.dawn": "Świt",
  "astral.dayLength": "Długość dnia",
  "astral.daylightThroughTheYear": "Długość dnia w ciągu roku",
  "astral.dayOfCycle": "dzień {day} z {total}",
  "astral.doesNotOccurToday": "Dziś nie występuje",
  "astral.dusk": "Zmierzch",
  "astral.earliestSunrise": "Najwcześniejszy wschód słońca",
  "astral.earliestSunset": "Najwcześniejszy zachód słońca",
  "astral.equinox": "Równonoc",
  "astral.equinoxIn": "Równonoc za {days, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}}",
  "astral.evening": "Wieczór",
  "astral.exactPhaseAt": "Dokładnie o {time}",
  "astral.firstQuarter": "Pierwsza kwadra",
  "astral.firstSunriseIn": "Pierwszy wschód słońca za {days, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}}",
  "astral.firstSunsetIn": "Pierwszy zachód słońca za {days, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}}",
  "astral.fullMoon": "Księżyc w pełni",
  "astral.goldenHourBegins": "Początek złotej godziny",
  "astral.goldenHourEnds": "Koniec złotej godziny",
  "astral.highestPoint": "Najwyższy punkt",
  "astral.inDays": "za {days, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}}",
  "astral.lastQuarter": "Ostatnia kwadra",
  "astral.latestSunrise": "Najpóźniejszy wschód słońca",
  "astral.latestSunset": "Najpóźniejszy zachód słońca",
  "astral.longestDay": "Najdłuższy dzień",
  "astral.lowestPoint": "Najniższy punkt",
  "astral.midday": "Południe",
  "astral.midnightSun": "Dzień polarny",
  "astral.midnightSunPeriod": "Dzień polarny",
  "astral.moon": "Księżyc",
  "astral.moonAltitude": "Wysokość",
  "astral.moonDirection": "Azymut",
  "astral.moonDistance": "Odległość",
  "astral.moonPhases": "Fazy księżyca",
  "astral.moonrise": "Wschód księżyca",
  "astral.moonset": "Zachód księżyca",
  "astral.morning": "Rano",
  "astral.nauticalDawn": "Świt żeglarski",
  "astral.nauticalDusk": "Zmierzch żeglarski",
  "astral.nauticalSunPhase": "{sunPhase} morskie",
  "astral.newMoon": "Nów",
  "astral.nextDay": "+1 dzień",
  "astral.nextRise": "następny wschód o {time}",
  "astral.noon": "Południe",
  "astral.noSunriseToday": "Dziś słońce nie wschodzi",
  "astral.nowAtBearing": "teraz {altitude} · azymut {direction}",
  "astral.ofDaylightLeft": "światła dziennego zostało",
  "astral.overTheNextThreeWeeks": "w ciągu najbliższych 3 tygodni",
  "astral.percentLit": "oświetlenie {percent}",
  "astral.polarNight": "Noc polarna",
  "astral.polarNightPeriod": "Noc polarna",
  "astral.remainingDaylight": "Pozostała długość dnia",
  "astral.rightNow": "Teraz",
  "astral.shortestDay": "Najkrótszy dzień",
  "astral.solarNoon": "Południe słoneczne",
  "astral.solstice": "Przesilenie",
  "astral.sunBelowHorizon": "Słońce {degrees}° pod horyzontem",
  "astral.sunEvents": "Zdarzenia słoneczne",
  "astral.sunNeverSets": "Słońce nie zachodzi",
  "astral.sunrise": "Wschód słońca",
  "astral.sunriseAndSunset": "Wschód i zachód słońca",
  "astral.sunriseAt": "Wschód słońca o {time}",
  "astral.sunset": "Zachód słońca",
  "astral.sunsetAt": "Zachód słońca o {time}",
  "astral.thisYearAtNorth": "W tym roku na {degrees}° szer. płn.",
  "astral.thisYearAtSouth": "W tym roku na {degrees}° szer. płd.",
  "astral.tonight": "Dziś w nocy",
  "astral.totalDaylight": "Długość dnia",
  "astral.upFor": "{duration} nad horyzontem",
  "astral.usableLight": "Użyteczne światło",
  "astral.vsAverage": "{percent} względem średniej",
  "astral.vsYesterday": "wzgl. wczoraj",
  "astral.waningCrescent": "Ubywający sierp",
  "astral.waningGibbous": "Ubywający garb",
  "astral.waxingCrescent": "Przybywający sierp",
  "astral.waxingGibbous": "Przybywający garb",
  "auth.alreadyHaveAccount": "Masz już konto?",
  "auth.authContainerTagline": "Twój osobisty panel pogodowy. Połącz swoje stacje i uzyskaj dane w czasie rzeczywistym na wyciągnięcie ręki.",
  "auth.backToLogin": "Powrót do logowania",
  "auth.catchPhrase": "Platforma analizy pogody",
  "auth.checkYourEmail": "Sprawdź swój e-mail",
  "auth.continueWithApple": "Kontynuuj z Apple",
  "auth.continueWithFacebook": "Kontynuuj z Facebook",
  "auth.continueWithGoogle": "Kontynuuj z Google",
  "auth.email": "Adres e-mail",
  "auth.emailRequiredLoginFacebook": "Uprawnienie do korzystania z poczty e-mail jest wymagane do logowania się przez Facebook",
  "auth.emailVerification": "Weryfikacja adresu e-mail",
  "auth.emailVerificationFailure": "Problem z weryfikacją adresu email",
  "auth.emailVerificationSuccess": "Twój email został poprawnie zweryfikowany",
  "auth.firstName": "Pierwsze imię",
  "auth.forgotPassword": "Zapomniałeś hasła?",
  "auth.forgotPasswordSubtitle": "Podaj swój adres e-mail, a wyślemy Ci link do zresetowania hasła.",
  "auth.lastName": "Nazwisko",
  "auth.login": "Zaloguj Się",
  "auth.loginSubtitle": "Witamy ponownie! Proszę podać swoje dane.",
  "auth.loginToSmartMixinDescription": "Wprowadź dane uwierzytelniające SmartMixin, aby uzyskać dostęp do swojego konta.",
  "auth.logout": "Wyloguj",
  "auth.logoutConfirmation": "Czy na pewno chcesz się rozłączyć?",
  "auth.noAccountYet": "Nie masz jeszcze konta?",
  "auth.or": "lub",
  "auth.password": "Hasło",
  "auth.passwordAgain": "Hasło ponownie",
  "auth.passwordReset": "Reset hasła",
  "auth.passwordResetSuccess": "Twoje hasło zostało poprawnie zaktualizowane",
  "auth.register": "Utwórz konto",
  "auth.registerDescription": "Utwórz bezpłatne konto SmartMixin, aby połączyć swoje stacje pogodowe, śledzić dane pogodowe i korzystać z zaawansowanych narzędzi analitycznych.",
  "auth.registerSubtitle": "Utwórz konto, aby rozpocząć.",
  "auth.registerSuccess": "Rejestracja powiodła się! Właśnie wysłaliśmy Ci link weryfikacyjny na {emailAddress} z dalszymi instrukcjami.",
  "auth.restorePassword": "Przywróć hasło",
  "auth.restorePasswordSuccess": "Właśnie wysłaliśmy Ci link do resetowania hasła na {emailAddress} z dalszymi instrukcjami.",
  "auth.sendReset": "Wyślij instrukcje resetowania",
  "auth.signInWithApple": "",
  "auth.socialAccount": "lub użyj swojego konta społecznościowego",
  "auth.welcome": "Witamy w SmartMixin",
  "auth.welcomeBack": "Witamy ponownie!",
  "calendar.april": "Kwiecień",
  "calendar.august": "Sierpień",
  "calendar.dateFormat": "Format daty",
  "calendar.day": "Dzień",
  "calendar.december": "Grudzień",
  "calendar.end": "Koniec",
  "calendar.february": "Luty",
  "calendar.hours": "godziny",
  "calendar.hoursShort": "godz.",
  "calendar.january": "Styczeń",
  "calendar.july": "Lipiec",
  "calendar.june": "Czerwiec",
  "calendar.last24Hours": "ostatnie 24 godziny",
  "calendar.last30Days": "ostatnie 30 dni",
  "calendar.last7Days": "ostatnie 7 dni",
  "calendar.march": "Marzec",
  "calendar.max": "Max",
  "calendar.may": "Maj",
  "calendar.month": "miesiąc",
  "calendar.months": "miesięcy",
  "calendar.november": "Listopad",
  "calendar.october": "Październik",
  "calendar.oneDay": "1 dzień",
  "calendar.oneHour": "1 godzina",
  "calendar.oneMonth": "1 miesiąc",
  "calendar.oneWeek": "1 tydzień",
  "calendar.previous24Hours": "Poprzednie 24 godziny",
  "calendar.previous30Days": "Poprzednie 30 dni",
  "calendar.previous7Days": "Poprzednie 7 dni",
  "calendar.previousDay": "Poprzedni dzień",
  "calendar.previousMonth": "Poprzedni miesiac",
  "calendar.previousWeek": "Poprzedni tydzień",
  "calendar.previousYear": "Poprzedni rok",
  "calendar.sameDayLastYear": "Ten sam dzień w zeszłym roku",
  "calendar.sameMonthLastYear": "Ten sam miesiąc w zeszłym roku",
  "calendar.selectADate": "Wybierz datę",
  "calendar.selectAggregation": "Wybierz wyświetlaną wartość",
  "calendar.selectAMonth": "Wybierz miesiąc",
  "calendar.selectAYear": "Wybierz rok",
  "calendar.selectGranularity": "Wybierz szczegółowość",
  "calendar.selectTimescale": "Wybierz skalę czasu",
  "calendar.september": "Wrzesień",
  "calendar.sixHours": "6-godzinny",
  "calendar.start": "Początek",
  "calendar.thirtyMinutes": "30 min",
  "calendar.threeHours": "3-godzinny",
  "calendar.use24HourFormat": "Użyj formatu 24h",
  "calendar.week": "Tydzień",
  "calendar.year": "Rok",
  "calendar.yesterday": "Wczoraj",
  "common.accountDeleted": "Twoje konto zostało pomyślnie usunięte.",
  "common.accountOnHold": "Połączenie z kontem wygasło. Połącz się ponownie, aby wznowić aktualizacje danych.",
  "common.add": "Dodaj",
  "common.addAStation": "Dodaj stację",
  "common.addToFavorites": "Dodaj do ulubionych",
  "common.addYourOwnStation": "Dodaj swoją stację",
  "common.afternoon": "Popołudnie",
  "common.alreadyPremium": "Masz już konto premium!",
  "common.alsoAvailableOn": "Dostępne również na:",
  "common.altitude": "Wysokość",
  "common.analysis": "Analiza",
  "common.aroundMe": "Wokół mnie",
  "common.articleCount": "{count, plural, one {# artykuł} few {# artykuły} many {# artykułów} other {# artykułów}}",
  "common.articleNotFound": "Nie znaleziono artykułu",
  "common.articleNotFoundDescription": "Szukany artykuł nie istnieje.",
  "common.average": "Średni",
  "common.averageOverThePeriod": "Średnia w okresie",
  "common.away": "Z dala",
  "common.back": "Wstecz",
  "common.backToHelpCenter": "Wróć do centrum pomocy",
  "common.backToHome": "Powrót do Strony Głównej",
  "common.bad": "Zły",
  "common.batteryLevel": "Poziom naładowania baterii",
  "common.bestValue": "Najlepsza Wartość",
  "common.billingDetailsAndroid": "W przypadku bezpłatnej oferty próbnej nie zostaniesz obciążony opłatą, jeśli anulujesz 24 godziny przed wygaśnięciem bezpłatnego okresu próbnego. Po zakończeniu okresu próbnego możesz w dowolnym momencie anulować subskrypcję SmartMixin w ustawieniach konta Google Play lub zostanie automatycznie odnowiony. Należy to zrobić 24 godziny przed końcem okresu subskrypcji, aby uniknąć naliczenia kolejnej opłaty pokazanej na przycisku powyżej. Płatności subskrypcyjne będą pobierane z konta Google Play po potwierdzeniu zakupu i po rozpoczęciu każdego okres odnowienia.",
  "common.billingDetailsIos": "W przypadku bezpłatnej oferty próbnej nie zostaniesz obciążony opłatą, jeśli anulujesz 24 godziny przed wygaśnięciem bezpłatnego okresu próbnego. Po zakończeniu okresu próbnego możesz w dowolnym momencie anulować subskrypcję SmartMixin w ustawieniach konta App Store lub zostanie automatycznie odnowiony. Należy to zrobić 24 godziny przed końcem okresu subskrypcji, aby uniknąć naliczenia kolejnej opłaty pokazanej na przycisku powyżej. Płatności subskrypcyjne będą pobierane z konta App Store po potwierdzeniu zakupu i po rozpoczęciu każdego okres odnowienia.",
  "common.boilerOn": "Bojler włączony",
  "common.browseByCategory": "Przeglądaj według kategorii",
  "common.calendarView": "Widok kalendarza",
  "common.cancel": "Anuluj",
  "common.cannotBeEmpty": "To pole nie może być puste.",
  "common.cardDetails": "Szczegóły karty",
  "common.categoryNotFound": "Nie znaleziono kategorii",
  "common.categoryNotFoundDescription": "Ta kategoria nie istnieje lub nie zawiera artykułów.",
  "common.charts": "Wykresy",
  "common.chartView": "Widok wykresu",
  "common.clearRecentLocations": "Wyczyść wszystko",
  "common.close": "Zamknij",
  "common.comparison": "Porównanie",
  "common.contactMe": "Skontaktuj się ze mną",
  "common.currentDay": "Dzisiaj",
  "common.currentLocation": "Aktualna lokalizacja",
  "common.currentObservations": "Aktualne dane pomiarowe",
  "common.currentRainEvent": "Bieżące zdarzenie związane z deszczem",
  "common.currentRate": "Intensywność deszczu",
  "common.currentWeatherConditions": "Obecne warunki",
  "common.customizeComparisonMetrics": "Dostosuj metryki",
  "common.customizeComparisonMetricsDescription": "Przeciągnij elementy, aby zmienić kolejność metryk porównania. Dotknij ikony oka, aby pokazać lub ukryć metryki.",
  "common.customizeDashboard": "Dostosuj",
  "common.customizeDashboardDescription": "Przeciągnij elementy, aby zmienić kolejność na pulpicie. Dotknij ikony oka, aby pokazać lub ukryć sekcje.",
  "common.customizedStationName": "Własna nazwa stacji",
  "common.dailyForecast": "Pogoda dzienna",
  "common.dashboard": "Ogólne",
  "common.default": "Domyślny",
  "common.defaultForecastModelChip": "Domyślny · {name}",
  "common.delete": "Usuń",
  "common.deleteAccount": "Usuń konto",
  "common.deleteAccountConfirmation": "Czy na pewno chcesz usunąć swoje konto? Ta czynność jest nieodwracalna.",
  "common.deleteAccountDescription": "Ta czynność usuwa Twoje konto i wszystkie informacje. Nie ma powrotu.",
  "common.details": "Szczegóły",
  "common.durationHours": "{hours} godz.",
  "common.durationHoursMinutes": "{hours} godz. {minutes} min",
  "common.durationMinutes": "{minutes} min",
  "common.edit": "Edytuj",
  "common.editor": "Edytor",
  "common.endTime": "Koniec",
  "common.evening": "Wieczór",
  "common.exitFullscreen": "Zamknij pełny ekran",
  "common.exploreWeatherMap": "Poznaj Mapę Pogody",
  "common.favoriteLocations": "Ulubione",
  "common.favoriteLocationsEmpty": "Możesz dodać do 5 ulubionych lokalizacji.",
  "common.favoriteStations": "Ulubione stacje",
  "common.feedbackHelpsImprove": "Twoja opinia pomaga nam ulepszać nasze artykuły pomocy.",
  "common.feedbackReasonNotAnswer": "Nie odpowiada na moje pytanie",
  "common.feedbackReasonOutdated": "Informacje są nieaktualne",
  "common.feedbackReasonUnclear": "Instrukcje są niejasne",
  "common.feedbackWhatWentWrong": "Na czym polegał problem?",
  "common.filterStationDescription": "Nie wyświetlaj stacji z niewiarygodnymi pomiarami",
  "common.filterStations": "Stacje filtrujące",
  "common.filterStationSourceDescription": "Wybierz dostawców stacji, których chcesz wyświetlić na mapie",
  "common.findStationsNearYou": "Znajdź stacje w pobliżu",
  "common.firmwareVersion": "Wersja oprogramowania",
  "common.forecast": "Prognoza",
  "common.forecastComparisonDescription": "Łatwe porównywanie modeli pogody z różnych serwisów",
  "common.forecastModelComparison": "Porównywanie modeli pogody",
  "common.forecastModelCoverage": "Zasięg",
  "common.forecastModelDescription": "Opis",
  "common.forecastModelDescription_AROME": "Wysokorozdzielczy model Météo France z rozwiązywaniem konwekcji nad Europą Zachodnią o rozdzielczości 1,3 km. Najlepszy w swojej klasie do krótkoterminowych prognoz we Francji; aktualizowany co trzy godziny.",
  "common.forecastModelDescription_ARPEGE_EU": "Europejskie gniazdo modelu ARPEGE Météo France o rozdzielczości 10 km. Średnioterminowe prognozy dla Europy, aktualizowane cztery razy dziennie.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Globalny numeryczny model pogody Météo France o rozdzielczości 25 km, działający do około 4 dni. Aktualizowany cztery razy dziennie.",
  "common.forecastModelDescription_DMI_DINI": "HARMONIE DINI od DMI: model dopuszczający konwekcję nad Europą Północno-Zachodnią — Dania, Beneluks, Irlandia, Wielka Brytania i Skandynawia — o rozdzielczości 2 km działający do 60 godzin, aktualizowany osiem razy dziennie. Zawiera zmodyfikowane otwarte dane DMI (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Globalny Deterministyczny System Prognozowania Environment Canada: ogólnoświatowy model średnioterminowy o rozdzielczości 15 km działający do 10 dni, aktualizowany dwa razy dziennie.",
  "common.forecastModelDescription_EC_HRDPS": "Wysokorozdzielczy Deterministyczny System Prognozowania Environment Canada: model dopuszczający konwekcję nad Kanadą i północną częścią Stanów Zjednoczonych o rozdzielczości 2,5 km działający do 48 godzin, aktualizowany cztery razy dziennie.",
  "common.forecastModelDescription_EC_RDPS": "Regionalny Deterministyczny System Prognozowania Environment Canada: model średnioterminowy nad Ameryką Północną o rozdzielczości 10 km, aktualizowany cztery razy dziennie.",
  "common.forecastModelDescription_ECMWF_HRES": "Flagowy model wysokiej rozdzielczości (IFS) Europejskiego Centrum Prognoz Średnioterminowych, powszechnie uznawany za najlepszy globalny system prognozowania na świecie. Obejmuje całą planetę w rozdzielczości 25 km do 15 dni, aktualizowany cztery razy dziennie. Zawiera zmodyfikowane otwarte dane ECMWF (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "Flagowy średnioterminowy globalny model NOAA. Obejmuje całą planetę z rozdzielczością 25 km do 16 dni, aktualizowany cztery razy dziennie.",
  "common.forecastModelDescription_HRRR_CONUS": "High-Resolution Rapid Refresh NOAA: model z rozwiązywaniem konwekcji nad kontynentalnymi Stanami Zjednoczonymi o rozdzielczości 3 km, aktualizowany co godzinę. Najlepiej nadaje się do bardzo krótkoterminowych prognoz burz i ekstremalnej pogody.",
  "common.forecastModelDescription_ICON": "Globalny model ICON od DWD o rozdzielczości 13 km obejmujący całą planetę do 7,5 dnia, aktualizowany cztery razy dziennie. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ICON-2I od ItaliaMeteo, prowadzony wspólnie z ARPAE: model dopuszczający konwekcję nad Włochami o rozdzielczości 2,2 km działający do 72 godzin, aktualizowany dwa razy dziennie. Zawiera otwarte dane ItaliaMeteo (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "Przebieg kontrolny ICON-CH1-EPS od MeteoSwiss: model dopuszczający konwekcję nad Alpami o rozdzielczości 1 km działający do 33 godzin, aktualizowany co trzy godziny.",
  "common.forecastModelDescription_ICON_CH2": "Przebieg kontrolny ICON-CH2-EPS od MeteoSwiss: model dopuszczający konwekcję nad Alpami — Szwajcaria i otaczający region alpejski — o rozdzielczości 2,1 km działający do 120 godzin, aktualizowany cztery razy dziennie.",
  "common.forecastModelDescription_ICON_DE": "Wysokorozdzielczy model DWD z rozwiązywaniem konwekcji nad Niemcami i krajami sąsiednimi o rozdzielczości 2,2 km. Krótkoterminowe prognozy aktualizowane dwa razy dziennie. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "Europejskie gniazdo modelu ICON DWD o rozdzielczości 7 km obejmujące Europę i Atlantyk Północny. Średnioterminowe prognozy aktualizowane cztery razy dziennie. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "Otwarta usługa prognozowania pogody Norweskiego Instytutu Meteorologicznego, łącząca wysokorozdzielcze modele nordyckie z danymi ECMWF, aby zapewnić ogólnoświatowe prognozy z wyprzedzeniem do 10 dni.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Gniazdo AROME nad francuskimi Antylami (Gwadelupa, Martynika) o rozdzielczości 2,5 km. Krótkoterminowe prognozy aktualizowane cztery razy dziennie.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Gniazdo AROME nad Gujaną Francuską o rozdzielczości 2,5 km. Krótkoterminowe prognozy aktualizowane cztery razy dziennie.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Gniazdo AROME nad Nową Kaledonią o rozdzielczości 2,5 km. Krótkoterminowe prognozy aktualizowane cztery razy dziennie.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Gniazdo AROME nad Polinezją Francuską o rozdzielczości 2,5 km. Krótkoterminowe prognozy aktualizowane cztery razy dziennie.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Gniazdo AROME nad Réunion i Majottą o rozdzielczości 2,5 km. Krótkoterminowe prognozy aktualizowane cztery razy dziennie.",
  "common.forecastModelDescription_NAM_CONUS": "Gniazdo modelu North American Mesoscale NOAA nad kontynentalnymi Stanami Zjednoczonymi o rozdzielczości 5 km. Krótkoterminowe prognozy aktualizowane cztery razy dziennie.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "Model North American Mesoscale NOAA obejmujący całą Amerykę Północną o rozdzielczości 32 km. Aktualizowany cztery razy dziennie.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "Flagowa prognoza SmartMixin. Dla każdej godziny w Twojej lokalizacji wybieramy najlepszy dostępny model — zazwyczaj wysokorozdzielczy model regionalny tam, gdzie taki istnieje (AROME we Francji, ICON-D2 w Niemczech, HRRR w USA, ARPEGE Europe na całym kontynencie…) i w innych miejscach wracamy do modelu globalnego — następnie uzupełniamy wszelkie luki ze źródeł sąsiednich. Wynikiem jest jedna płynna prognoza obejmująca dowolne miejsce na świecie do 14 dni, automatycznie odświeżana za każdym razem, gdy aktualizowany jest którykolwiek z podstawowych modeli.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Zastrzeżona globalna prognoza Weatherflow, która łączy wiele numerycznych modeli pogody z obserwacjami z jej sieci stacji pogodowych Tempest. 10-dniowy globalny horyzont.",
  "common.forecastModelDetailTitle": "Model prognozy",
  "common.forecastModelScopeGlobal": "Globalny",
  "common.forecastModelScopeGlobalDescription": "Ten model obejmuje całą planetę.",
  "common.forecastModelScopeRegional": "Regionalny",
  "common.forecastModelScopeRegionalDescription": "Ten model obejmuje tylko określony region.",
  "common.forecastModelSpecifications": "Specyfikacja",
  "common.forecastSources": "Źródła prognozy pogody",
  "common.freeAccount": "Darmowe konto",
  "common.freeSubscription": "Darmowa subskrypcja premium",
  "common.freeTrialForPeriod": "Bezpłatny okres próbny przez {period} dni",
  "common.frequency": "Częstotliwość",
  "common.full": "Pełny",
  "common.fullscreen": "Pełny ekran",
  "common.getStartedFree": "Zacznij Za Darmo",
  "common.getUnlimitedAccess": "Nieograniczony dostęp do:",
  "common.good": "Dobry",
  "common.hail": "Grad",
  "common.help": "Pomoc",
  "common.helpCategoryAccount": "Konto",
  "common.helpCategoryBilling": "Płatności",
  "common.helpCategoryGettingStarted": "Pierwsze kroki",
  "common.helpCategoryProviders": "Dostawcy",
  "common.helpCategoryStations": "Stacje",
  "common.helpCategoryTroubleshooting": "Rozwiązywanie problemów",
  "common.helpCenter": "Centrum pomocy",
  "common.helpCenterDescription": "Znajdź odpowiedzi na najczęstsze pytania i dowiedz się, jak w pełni wykorzystać SmartMixin.",
  "common.hg": "Ochrona przed mrozem",
  "common.hidden": "Ukryte",
  "common.hiddenSensors": "Ukryte czujniki",
  "common.hiddenStations": "Ukryte stacje",
  "common.hiddenStationsDescription": "Możesz odłączyć stację, stukając obok ikony oka.",
  "common.high": "Wysoka",
  "common.home": "Strona główna",
  "common.homeConnectService": "Posiadasz stację pogodową? Podłącz swoją usługę",
  "common.homeInformation": "Informacje o domu",
  "common.homeIntroduction": "Zacznij podłączać swoje konta zewnętrzne, aby korzystać z funkcji SmartMixin.",
  "common.homeName": "Nazwa domu",
  "common.homeSubtitle": "Twoja pogoda, wszystko w jednym miejscu",
  "common.horizon": "Horyzont",
  "common.horizonValue": "do {value} godz.",
  "common.hour": "Godzina",
  "common.iDontKnowYet": "Jeszcze nie wiem",
  "common.indoor": "Wewnątrz",
  "common.lastRainEvent": "Ostatnie wydarzenie deszczowe",
  "common.lastUpdate": "Ostatnia aktualizacja",
  "common.legendHeavy": "Silne",
  "common.legendLight": "Słabe",
  "common.legendLightningHelp": "Kolor pokazuje wiek każdego wyładowania w ciągu ostatnich {minutes} minut — najnowsze na biało, najstarsze na ciemnoczerwono.",
  "common.legendNewest": "Najnowsze",
  "common.legendOldest": "Najstarsze",
  "common.legendStationsHelp": "Kolor znacznika odzwierciedla wartość wybranego wskaźnika.",
  "common.lightningDataAttribution": "Dane o wyładowaniach: Blitzortung.org",
  "common.lightningStrikes": "Wyładowania atmosferyczne",
  "common.lightningStrikesDescription": "Pokazuj wyładowania atmosferyczne na mapie w czasie rzeczywistym",
  "common.linkToSection": "Link do tej sekcji",
  "common.loading": "Ładowanie",
  "common.location": "Lokalizacja",
  "common.locationAddedToFavorites": "Lokalizacja dodana do ulubionych",
  "common.locationNotGranted": "Zezwolenie na lokalizację nie jest przyznane. Zapoznaj się z lokalizacją w ustawieniach urządzenia.",
  "common.locationRemovedFromFavorites": "Lokalizacja usunięta z ulubionych",
  "common.locations": "Lokalizacje",
  "common.low": "Niski",
  "common.manage": "Zarządzaj",
  "common.manageAccount": "Zarządzaj kontem",
  "common.manageMySubscription": "Zarządzaj moją subskrypcją",
  "common.manageSensors": "Zarządzaj czujnikami",
  "common.manageSensorsDescription": "Przeciągnij elementy, aby zmienić kolejność czujników. Dotknij ikony oka, aby pokazać lub ukryć czujniki. Dotknij nazwy, aby ją zmienić.",
  "common.manualBoost": "Ręczne zwiększenie",
  "common.manualSetpointUntil": "Ręczna nastawa do",
  "common.mapLayers": "Warstwy mapy",
  "common.mapLegend": "Legenda mapy",
  "common.maxFavoriteLocationsReached": "Możesz mieć tylko do 5 ulubionych lokalizacji. Usuń jeden, aby dodać drugi.",
  "common.maximum": "Maksimum",
  "common.measureToDisplay": "Pomiar do wyświetlenia",
  "common.medium": "Średni",
  "common.meshSize": "Rozmiar siatki",
  "common.minimum": "Minimum",
  "common.minRead": "{minutes} min czytania",
  "common.modifyFavoriteStations": "Zmodyfikuj ulubione stacje",
  "common.modifyFavoriteStationsDescription": "Możesz ponownie zamówić swoje ulubione stacje, przeciągając je. Możesz je również usunąć z listy.",
  "common.moduleType": "Typ modułu",
  "common.monthTotal": "Ten miesiąc",
  "common.more": "Więcej",
  "common.moreInformation": "Więcej Informacji",
  "common.morning": "Rano",
  "common.myLocation": "Moja lokalizacja",
  "common.nearbyWeatherStations": "Pobliskie stacje pogodowe",
  "common.next": "Następny",
  "common.nextHours": "Następne godziny",
  "common.night": "Noc",
  "common.no": "Nie",
  "common.noAccountNeeded": "Konto nie jest wymagane",
  "common.noDataForThisPeriod": "Brak danych za ten okres",
  "common.noLocationsFound": "Nie znaleziono lokalizacji",
  "common.noNetatmoWeatherStationYet": "Nie masz jeszcze stacji meteorologicznej.",
  "common.noOutdoorModule": "Dla tej stacji nie ma działającego modułu zewnętrznego.",
  "common.noSearchResults": "Żaden artykuł nie pasuje do wyszukiwania",
  "common.noStationsFound": "Nie znaleziono stacji",
  "common.noThermostatYet": "Nie masz jeszcze termostatu.",
  "common.notNow": "Nie teraz",
  "common.notPurchasedYet": "Wydaje się, że nie został jeszcze zakupiony.",
  "common.now": "Teraz",
  "common.noWeatherStation": "Brak stacji pogody",
  "common.noWeatherStationYet": "Nie masz jeszcze stacji meteorologicznej.",
  "common.numberOfActiveWarnings": "{warning_count} aktywne ostrzeżenia pogodowe",
  "common.onThisPage": "Na tej stronie",
  "common.openSettings": "Otwórz ustawienia",
  "common.orChooseMonthly": "Lub wybierz miesięcznie:",
  "common.outdatedModule": "Dane tego modułu są nieaktualne.",
  "common.outdoor": "Na wolnym powietrzu",
  "common.outdoorTemperature": "Temperatura zewnętrzna",
  "common.pageNotFound": "Strona Nie Znaleziona",
  "common.pageNotFoundDescription": "Strona, której szukasz, nie istnieje lub została przeniesiona.",
  "common.passwordUpdated": "Hasło zostało pomyślnie zaktualizowane.",
  "common.personalWeatherIntelligence": "Twoja Osobista Inteligencja Pogodowa",
  "common.platformMobileApp": "Aplikacja mobilna",
  "common.platformMobileOnly": "Tylko w aplikacji mobilnej",
  "common.platformWebApp": "Aplikacja internetowa",
  "common.platformWebOnly": "Tylko w aplikacji internetowej",
  "common.popularArticles": "Popularne artykuły",
  "common.premiumAccount": "Konto premium",
  "common.premiumDescription": "Subskrypcja Premium odblokowuje szeroką gamę dodatkowych funkcji, takich jak zaawansowana analiza pogody, porównanie wykresów, modele prognoz regionalnych i wiele więcej.",
  "common.premiumFeatureAlerts": "Alerty Pogodowe",
  "common.premiumFeatureAnalysis": "Zaawansowana Analiza Pogody",
  "common.premiumFeatureCharts": "Porównania Wykresów",
  "common.premiumFeatureExport": "Eksport Danych",
  "common.premiumFeatureForecast": "Regionalne Modele Prognoz",
  "common.premiumFeatureNotification": "Widget Paska Stanu",
  "common.premiumFeatureTitle": "Funkcja Premium",
  "common.premiumFeatureWidgets": "Widżety ekranu głównego",
  "common.pressureSummary": "Synteza ciśnienia",
  "common.previous": "Poprzedni",
  "common.previousHours": "Poprzednie godziny",
  "common.profileUpdated": "Profil został pomyślnie zaktualizowany.",
  "common.purchasedNetatmoPro": "Wcześniej kupiłeś Netatmo Pro ({date}). Zapisz się do jednej z poniższych ofert, aby mieć dostęp do wszystkich funkcji premium aplikacji.",
  "common.radarDataAttribution": "Dane radarowe: NOAA / EUMETNET OPERA via LibreWXR",
  "common.rain": "Deszcz",
  "common.rainEvents": "Zdarzenia deszczowe",
  "common.rainfallMeasurement": "Pomiar opadów",
  "common.rainRadar": "Radar opadów",
  "common.rainRadarDescription": "Wyświetl nakładkę radaru deszczu na mapie",
  "common.rainSummary": "Podsumowanie opadów",
  "common.range": "Zasięg",
  "common.recentLocations": "Ostatni",
  "common.recentLocationsEmpty": "Wynowana historia jest pusta.",
  "common.recentStations": "Ostatnie stacje",
  "common.relatedArticles": "Powiązane artykuły",
  "common.relay": "Przekaźnik",
  "common.removeFromFavorites": "Usuń z ulubionych",
  "common.renameSensors": "Zmień nazwy czujników",
  "common.resetZoom": "Resetuj powiększenie",
  "common.restorePurchase": "Przywróć zakup",
  "common.room": "Pokój",
  "common.rooms": "Pokoje",
  "common.savingsPercent": "Oszczędź {percent}%",
  "common.searchArticles": "Szukaj artykułów...",
  "common.searchForALocation": "Wyszukaj lokalizację...",
  "common.searchForLocation": "Szukaj lokalizacji",
  "common.searchForWeatherStation": "Szukaj stacji pogody",
  "common.searchResults": "Wyniki wyszukiwania",
  "common.searchResultsEmpty": "Nie znaleziono żadnych wyników.",
  "common.searchResultsFound": "{count, plural, one {Znaleziono # wynik} few {Znaleziono # wyniki} many {Znaleziono # wyników} other {Znaleziono # wyniku}}",
  "common.searchStationsDescription": "Wpisz miasto, adres lub nazwę miejsca, aby znaleźć pobliskie stacje pogodowe.",
  "common.searchStationsHint": "Użyj paska wyszukiwania powyżej, aby odkryć stacje pogodowe w dowolnym miejscu na świecie.",
  "common.selectStationForComparison": "Szukaj stacji do porównania",
  "common.selectWeatherForecastProvider": "Wybierz dostawcę pogody",
  "common.serialNumber": "Numer seryjny",
  "common.share": "Udostępnij",
  "common.shareOutdoorMeasures": "Udostępnij pomiary zewnętrzne",
  "common.shareOutdoorMeasuresDescription": "Udostęnij swoją pogodę",
  "common.shareYourWeather": "Udostępnij swoją pogodę",
  "common.signalStrength": "Siła sygnału",
  "common.skip": "Pominąć",
  "common.smartThermostat": "Inteligentny termostat",
  "common.smartValve": "Inteligentny zawór",
  "common.snow": "Śnieg",
  "common.start": "Start",
  "common.startFreeTrial": "Rozpocznij Bezpłatny Okres Próbny",
  "common.startTime": "Początek",
  "common.station": "stacja",
  "common.stationAddedToFavorites": "Stacje dodane do ulubionych",
  "common.stationComparison": "Porównanie stacji",
  "common.stationComparisonDescription": "Porównaj dane historyczne z inną stacją pogody",
  "common.stationInformation": "Informacje o stacji",
  "common.stationName": "Nazwa stacji",
  "common.stationObservationsDescription": "Wyświetl najnowsze obserwacje ze stacji pogodowych",
  "common.stationRemovedFromFavorites": "Stacja usunięta z ulubionych",
  "common.stations": "stacje",
  "common.stationsNear": "Stacje w pobliżu",
  "common.stationType": "Typ stacji",
  "common.statusOffline": "Offline",
  "common.statusOnline": "Online",
  "common.statusStale": "Nieaktualne",
  "common.statusSyncing": "Synchronizacja",
  "common.stillNeedHelp": "Nadal potrzebujesz pomocy?",
  "common.stillNeedHelpDescription": "Jeśli ten artykuł nie odpowiedział na Twoje pytanie, chętnie pomogę Ci bezpośrednio.",
  "common.subscribeNow": "Subskrybuj teraz - bez okresu próbnego",
  "common.sumOverThePeriod": "Skumulowana w okresie",
  "common.switchToPremium": "Przełącz na SmartMixin Premium",
  "common.temperatureShort": "Temp.",
  "common.temperatureSummary": "Podsumowanie temperatury",
  "common.thankYouForFeedback": "Dziękujemy za opinię!",
  "common.thenPrice": "potem {price}",
  "common.timeSelection": "Wybór czasu",
  "common.timezone": "Strefa czasowa",
  "common.totalDuration": "Całkowity czas trwania",
  "common.tryAnotherLocation": "Nie znaleźliśmy stacji pogodowych w pobliżu tej lokalizacji. Spróbuj wyszukać w innym obszarze.",
  "common.unknown": "Nieznany",
  "common.untilChanged": "Do czasu zmiany",
  "common.untilTime": "Do {time}",
  "common.updateAvailable": "Dostępna aktualizacja",
  "common.updateAvailableOpenAppStore": "Dotknij, aby otworzyć App Store",
  "common.updateAvailableOpenGooglePlay": "Dotknij, aby otworzyć Google Play",
  "common.updateAvailableVersion": "Dostępna aktualizacja: v{version}",
  "common.upgrade": "Upgrade",
  "common.upgradeRequiredAndroid": "Wymagana jest aktualizacja aplikacji, przejdź do Google Play, aby ją zaktualizować.",
  "common.upgradeRequiredIos": "Wymagana jest aktualizacja aplikacji, przejdź do sklepu z aplikacjami, aby ją zaktualizować.",
  "common.validate": "Potwierdzenie",
  "common.validEmail": "Wymagany jest prawidłowy adres e-mail.",
  "common.very_low": "Bardzo niski",
  "common.viewAsList": "Lista",
  "common.viewAsPeriods": "Pory dnia",
  "common.visitNetatmoWebsite": "Odwiedź stronę Netatmo",
  "common.wasArticleHelpful": "Czy ten artykuł był pomocny?",
  "common.weatherCondition": "Warunki pogodowe",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain to dodatkowe źródło danych dostarczane przez system pogodowy Tempest, wykorzystujący technologię Nearcast. Dane NC Rain to szacunkowa średnia akumulacja opadów wokół urządzenia Tempest na poziomie sąsiedztwa",
  "common.weatherForecastModels": "Model prognozowania pogody",
  "common.weatherIntelligencePlatform": "Platforma Inteligencji Pogodowej",
  "common.weatherMap": "Mapa pogody",
  "common.weatherMapMetaDescription": "SmartMixin oferuje interaktywne mapy pogody i radaru dla warunków pogodowych na całym świecie.",
  "common.weatherObservations": "Obserwacje pogodowe",
  "common.weatherStation": "Stacja pogodowa",
  "common.weatherStations": "Stacje pogodowe",
  "common.welcome": "Witamy w SmartMixin!",
  "common.whenBackHome": "Kiedy wrócisz do domu?",
  "common.wifiStrength": "siła Wi-Fi",
  "common.wind": "Wiatr",
  "common.windMeasurement": "Pomiar wiatru",
  "common.windSpeed": "Prędkość wiatru",
  "common.windSummary": "Synteza wiatru",
  "common.yearToDate": "W tym roku",
  "common.yes": "Tak",
  "common.zoomImage": "Powiększ obraz",
  "forecastMaps.addColor": "Dodaj kolor",
  "forecastMaps.addLayer": "Dodaj warstwę",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Powrót do map",
  "forecastMaps.browseMaps": "Przeglądaj mapy",
  "forecastMaps.build": "Generuj",
  "forecastMaps.buildCompleted": "Generowanie zakończone",
  "forecastMaps.builderMetaDescription": "Twórz własne mapy prognoz z warstw modeli pogodowych.",
  "forecastMaps.builderTitle": "Kreator map",
  "forecastMaps.buildFailed": "Generowanie nie powiodło się. Spróbuj ponownie.",
  "forecastMaps.buildNotPossible": "Tej mapy nie można jeszcze wygenerować — brak dostępnych danych prognostycznych.",
  "forecastMaps.buildProgress": "Renderowanie… {completed}/{total} kroków",
  "forecastMaps.buildStarting": "Rozpoczynanie generowania…",
  "forecastMaps.byModel": "Według modelu",
  "forecastMaps.byZone": "Według strefy",
  "forecastMaps.colormap": "Skala kolorów",
  "forecastMaps.colormapCustom": "Własne kolory",
  "forecastMaps.colormapGroupDomain": "Zestawy pogodowe",
  "forecastMaps.colormapGroupMatplotlib": "Zestawy naukowe",
  "forecastMaps.colorScale": "Skala kolorów",
  "forecastMaps.comingSoon": "Ten widok będzie wkrótce dostępny.",
  "forecastMaps.contourLevels": "Poziomy izolinii",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Francja",
  "forecastMaps.countryGermany": "Niemcy",
  "forecastMaps.countryItaly": "Włochy",
  "forecastMaps.countryScandinavia": "Skandynawia",
  "forecastMaps.countrySpain": "Hiszpania",
  "forecastMaps.countrySwitzerland": "Szwajcaria",
  "forecastMaps.countryUnitedStates": "Stany Zjednoczone",
  "forecastMaps.customColormapMinColors": "Własna skala kolorów wymaga co najmniej dwóch kolorów",
  "forecastMaps.customExtent": "Własny zasięg",
  "forecastMaps.deleteMap": "Usuń mapę",
  "forecastMaps.deleteMapBody": "„{name}” i jej wyrenderowane przebiegi zostaną trwale usunięte.",
  "forecastMaps.deleteMapTitle": "Usunąć tę mapę?",
  "forecastMaps.displayName": "Wyświetlana nazwa",
  "forecastMaps.downloadMp4": "Pobierz MP4",
  "forecastMaps.downscaling": "Współczynnik przerzedzenia chorągiewek",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Narysuj obszar",
  "forecastMaps.east": "Wschód",
  "forecastMaps.editMap": "Edytuj mapę",
  "forecastMaps.exportBuilding": "Przygotowywanie wideo…",
  "forecastMaps.exportError": "Eksport wideo nie powiódł się. Spróbuj ponownie.",
  "forecastMaps.exportMp4": "Eksportuj MP4",
  "forecastMaps.exportNotReady": "Wideo nie jest jeszcze gotowe. Spróbuj ponownie później.",
  "forecastMaps.extentDrawHint": "Przeciągnij po mapie, aby narysować obszar",
  "forecastMaps.extentInvalid": "Zachód musi być mniejszy niż wschód, a południe mniejsze niż północ",
  "forecastMaps.extentPanZoomHint": "Przesuwaj i powiększaj, aż obszar wypełni ramkę",
  "forecastMaps.flipbookView": "Animacja",
  "forecastMaps.forecastModel": "Model prognozy",
  "forecastMaps.forkAndEdit": "Duplikuj i edytuj",
  "forecastMaps.height": "Wysokość (cale)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.invalidHexColor": "Nieprawidłowy kolor — użyj #RRGGBB",
  "forecastMaps.layers": "Warstwy",
  "forecastMaps.layerTypeBarbs": "Chorągiewki wiatru",
  "forecastMaps.layerTypeContour": "Izolinie",
  "forecastMaps.layerTypeFilledContour": "Wypełnione izolinie",
  "forecastMaps.layerTypeMagnitude": "Wielkość",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Pole wektorowe",
  "forecastMaps.leave": "Wyjdź",
  "forecastMaps.levelsCount": "Liczba",
  "forecastMaps.levelsInvalid": "Nieprawidłowe poziomy izolinii",
  "forecastMaps.levelsModeArange": "Stały krok",
  "forecastMaps.levelsModeExplicit": "Jawne wartości",
  "forecastMaps.levelsModeLinspace": "Równomiernie rozłożone (liczba)",
  "forecastMaps.levelsStep": "Krok",
  "forecastMaps.levelsValues": "Wartości",
  "forecastMaps.levelsValuesHint": "Rozdzielone przecinkami, rosnąco",
  "forecastMaps.localTimeHint": "Wyświetlane w Twoim czasie lokalnym",
  "forecastMaps.map": "Mapa",
  "forecastMaps.mapDescription": "Opis",
  "forecastMaps.mapName": "Nazwa mapy",
  "forecastMaps.mapNameRequired": "Wpisz nazwę",
  "forecastMaps.mapSettings": "Ustawienia mapy",
  "forecastMaps.mapView": "Mapa interaktywna",
  "forecastMaps.maxLayersReached": "Ta mapa osiągnęła maksimum {max} warstw.",
  "forecastMaps.maxValue": "Wartość maksymalna",
  "forecastMaps.memoryBudgetExceeded": "Rozdzielczość przekracza budżet renderowania — zmniejsz DPI lub wysokość",
  "forecastMaps.memoryBudgetUsage": "Budżet renderowania: {percent}%",
  "forecastMaps.metaDescription": "Animowane mapy prognoz generowane z przebiegów modeli pogodowych.",
  "forecastMaps.metric": "Parametr",
  "forecastMaps.metricRequired": "Wybierz parametr",
  "forecastMaps.metricUnavailable": "Niedostępny dla tego modelu",
  "forecastMaps.minBelowMax": "Minimum musi być mniejsze niż maksimum",
  "forecastMaps.minMaxRequired": "Wartości minimalna i maksymalna są wymagane dla tego typu warstwy",
  "forecastMaps.minValue": "Wartość minimalna",
  "forecastMaps.modelNoRun": "Brak ukończonego przebiegu",
  "forecastMaps.moveLayerDown": "Przesuń w dół",
  "forecastMaps.moveLayerUp": "Przesuń w górę",
  "forecastMaps.myMaps": "Moje mapy",
  "forecastMaps.nanClipToMin": "Ogranicz do minimum",
  "forecastMaps.nanMask": "Maskuj",
  "forecastMaps.nanPolicy": "Brakujące dane",
  "forecastMaps.nanSkip": "Pomiń",
  "forecastMaps.newMap": "Nowa mapa",
  "forecastMaps.noCompletedRun": "Ta mapa nie została jeszcze wygenerowana. Sprawdź ponownie wkrótce.",
  "forecastMaps.noLayers": "Brak warstw. Dodaj warstwę, aby rozpocząć.",
  "forecastMaps.noMapsAvailable": "Mapy prognoz nie są jeszcze dostępne.",
  "forecastMaps.north": "Północ",
  "forecastMaps.opacity": "Krycie",
  "forecastMaps.overlayLegend": "Legenda",
  "forecastMaps.pause": "Pauza",
  "forecastMaps.play": "Odtwórz",
  "forecastMaps.pointValueError": "Nie udało się wczytać prognozy dla tego punktu.",
  "forecastMaps.pointValueLoading": "Wczytywanie prognozy…",
  "forecastMaps.pointValueUnavailable": "Brak danych dla tej godziny.",
  "forecastMaps.presets": "Gotowe",
  "forecastMaps.preview": "Podgląd",
  "forecastMaps.previewEmptyHint": "Skonfiguruj co najmniej jedną prawidłową warstwę, aby wyrenderować podgląd.",
  "forecastMaps.previewFailed": "Podgląd nie powiódł się",
  "forecastMaps.previewHour": "Godzina prognozy",
  "forecastMaps.previewRendering": "Renderowanie podglądu…",
  "forecastMaps.projection": "Odwzorowanie",
  "forecastMaps.projectionLambertConformal": "Lamberta wiernokątne",
  "forecastMaps.projectionMercator": "Merkatora",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereograficzne",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Ameryka Północna",
  "forecastMaps.removeColor": "Usuń kolor",
  "forecastMaps.removeLayer": "Usuń warstwę",
  "forecastMaps.retry": "Spróbuj ponownie",
  "forecastMaps.run": "Przebieg: {run}",
  "forecastMaps.save": "Zapisz",
  "forecastMaps.selectExtentOnMap": "Wybierz obszar na mapie",
  "forecastMaps.south": "Południe",
  "forecastMaps.title": "Mapy prognoz",
  "forecastMaps.uMetric": "Składowa U",
  "forecastMaps.unitConversion": "Konwersja jednostek",
  "forecastMaps.unitNone": "Brak",
  "forecastMaps.unsavedChangesBody": "Masz niezapisane zmiany. Wyjść i je odrzucić?",
  "forecastMaps.unsavedChangesTitle": "Niezapisane zmiany",
  "forecastMaps.useCurrentView": "Użyj bieżącego widoku",
  "forecastMaps.useModelDomain": "Wyłączone: używany jest pełny obszar modelu",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Parametry U i V muszą się różnić",
  "forecastMaps.validTime": "Ważność: {time}",
  "forecastMaps.valueBetween": "Musi być między {min} a {max}",
  "forecastMaps.variable": "Zmienna",
  "forecastMaps.viewMap": "Zobacz mapę",
  "forecastMaps.vMetric": "Składowa V",
  "forecastMaps.west": "Zachód",
  "forecastMaps.windAnimation": "Animacja wiatru",
  "intro.locationDescription": "Włącz dostęp do lokalizacji, aby uzyskać dokładne prognozy dostosowane do Twojej dokładnej okolicy — koniec z uniwersalnymi prognozami.",
  "intro.locationTitle": "Prognozy stworzone dla Ciebie",
  "intro.notificationDescription": "Włącz powiadomienia, aby otrzymywać szybkie alerty o zmianach pogody, które są dla Ciebie ważne — deszcz, śnieg lub poważne warunki, dokładnie wtedy, gdy potrzebujesz wiedzieć.",
  "intro.notificationsTitle": "Nigdy nie przegap zmiany pogody",
  "intro.readyDescription": "Ciesz się precyzyjnymi prognozami, aktualnymi informacjami o pogodzie i danymi ze stacji na całym świecie — wszystko w jednej potężnej aplikacji.",
  "intro.readyTitle": "Jesteś gotowy!",
  "intro.welcomeDescription": "Uzyskaj hiperlokalne prognozy od najlepszych agencji meteorologicznych — plus dostęp do ponad 40 000 stacji pogodowych na całym świecie, aby zobaczyć rzeczywiste warunki, przeszłe i obecne.",
  "intro.welcomeTitle": "Twoja pogoda, na nowo przemyślana",
  "landing.alerts": "Alerty",
  "landing.alertsDescription": "Twórz własne alerty i otrzymuj powiadomienia, gdy tylko zostaną uruchomione.",
  "landing.featureAlertsDescription": "Ustaw własne alerty dla warunków, które Cię interesują—temperatura, wiatr, opady i więcej.",
  "landing.featureAlertsTitle": "Inteligentne alerty",
  "landing.featureAnalyticsDescription": "Zagłęb się w swoje dane dzięki interaktywnym wykresom, porównaniom obok siebie i analizie trendów wykraczającej poza podstawowe metryki.",
  "landing.featureAnalyticsTitle": "Potężna analityka",
  "landing.featureExportDescription": "Pobierz swoje dane w formacie CSV do analizy w Excel, integracji z innymi systemami lub kopii zapasowej.",
  "landing.featureExportTitle": "Eksportuj wszędzie",
  "landing.featureForecastDescription": "Porównaj prognozy z ponad 10 modeli pogodowych, w tym GFS, ECMWF, ICON i innych, aby zobaczyć, który działa najlepiej dla Twojej lokalizacji.",
  "landing.featureForecastTitle": "Porównanie prognoz",
  "landing.featureHistoryDescription": "Dostęp do danych historycznych w skali godzinowej, dziennej i miesięcznej. Eksportuj do CSV do badań lub archiwów osobistych.",
  "landing.featureHistoryTitle": "Bogata historia",
  "landing.featureMultiBrandDescription": "Połącz stacje Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow i innych—wszystko w jednym panelu.",
  "landing.featureMultiBrandTitle": "Wsparcie wielu marek",
  "landing.featuresSubtitle": "Zaprojektowane dla entuzjastów pogody, którzy wymagają więcej niż podstawowa aplikacja stacji pogodowej.",
  "landing.featuresTitle": "Wszystko, czego potrzebujesz do analizy pogody",
  "landing.finalCtaButton": "Utwórz darmowe konto",
  "landing.finalCtaSubtitle": "Dołącz do tysięcy entuzjastów pogody, którzy ufają SmartMixin w kwestii swoich danych pogodowych.",
  "landing.finalCtaTitle": "Gotowy ulepszyć swoje doświadczenie pogodowe?",
  "landing.forecastDescription": "Uzyskaj dostęp do najlepszych modeli prognoz pogody i porównaj je, aby uzyskać własne wyobrażenie o tym, jaka będzie pogoda.",
  "landing.forecasts": "Prognozy",
  "landing.heroCta": "Zacznij za darmo",
  "landing.heroDescription": "Połącz wiele stacji pogodowych dowolnej marki, porównuj modele prognoz i analizuj swoje dane za pomocą szczegółowych wykresów i eksportów.",
  "landing.heroSecondaryCta": "Zobacz funkcje",
  "landing.heroTagline": "Dla miłośników pogody",
  "landing.heroTitle": "Wszystkie dane pogodowe. Jedna platforma.",
  "landing.pricingFeatureAdvancedMetrics": "Zaawansowane metryki",
  "landing.pricingFeatureAlerts": "Własne alerty",
  "landing.pricingFeatureExport": "Eksport danych (CSV)",
  "landing.pricingFeatureForecastComparison": "Porównanie prognoz",
  "landing.pricingFeatureForecasts": "Modele prognoz",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "Wszystkie modele (10+)",
  "landing.pricingFeatureReports": "Analizy i raporty",
  "landing.pricingFeatureStationComparison": "Porównanie stacji",
  "landing.pricingFeatureWidgets": "Widżety na ekranie głównym",
  "landing.pricingFeatureYearOverYear": "Analiza rok do roku",
  "landing.pricingFree": "Darmowy",
  "landing.pricingFreeCta": "Rozpocznij",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Najpopularniejszy",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Rozpocznij",
  "landing.pricingPremiumDescription": "Od 1,99 €/miesiąc — subskrybuj w sieci, App Store lub Google Play",
  "landing.pricingSubtitle": "Zacznij za darmo, ulepsz gdy potrzebujesz więcej.",
  "landing.pricingTitle": "Proste, przejrzyste ceny",
  "landing.smartMixinDescription": "SmartMixin to aplikacja zapewniająca dostęp do Twojej stacji pogodowej i ponad 40 000 innych stacji na całym świecie. Pomaga zobaczyć i zrozumieć dane pogodowe.",
  "landing.statBrands": "Obsługiwane marki",
  "landing.statForecasts": "Modele prognozy",
  "landing.statStations": "Połączonych stacji",
  "landing.supportedDevices": "Wspierane urządzenia",
  "landing.supportedDevicesDescription": "Oprócz stacji Światowej Organizacji Meteorologicznej SmartMixin obsługuje coraz większą liczbę marek stacji pogodowych.",
  "landing.supportedDevicesNote": "Plus ponad 40 000 publicznych stacji Światowej Organizacji Meteorologicznej",
  "landing.supportedDevicesSubtitle": "Połącz stacje pogodowe wiodących marek i zobacz wszystkie dane w jednym miejscu.",
  "landing.supportedDevicesTitle": "Działa z Twoimi stacjami",
  "landing.thermostatDescription": "Podłącz termostat Netatmo, aby skorelować wzorce ogrzewania z warunkami na zewnątrz.",
  "landing.thermostatManufacturers": "Producenci termostatów otrzymują również wsparcie w zakresie korelacji ogrzewania z warunkami zewnętrznymi.",
  "landing.thermostatTitle": "Integracja z inteligentnym domem",
  "landing.weatherAnalysis": "Analiza pogody",
  "landing.weatherAnalysisDescription": "SmartMix zawiera wiele wizualizacji danych, które pozwalają analizować dane pogodowe.",
  "landing.weatherAssistant": "Twój asystent pogodowy",
  "landing.weatherAssistantDescription": "Niezależnie od tego, czy interesują Cię aktualne, historyczne czy prognozowane warunki pogodowe, SmartMixin zapewnia liczne spostrzeżenia, kiedy tylko ich potrzebujesz.",
  "landing.weatherForecastModels": "Modele prognoz pogody",
  "landing.weatherForecastModelsDescription": "SmartMixin zapewnia dostęp do najdokładniejszych modeli prognoz pogody. Możesz łatwo porównać ich prognozy i stworzyć własny pomysł.",
  "landing.weatherMap": "Mapa pogody",
  "landing.weatherMapDescription": "Przeglądaj mapę i wizualizuj, jaka jest pogoda w dowolnym miejscu na świecie.",
  "network.cancelError": "Żądanie zostało anulowane",
  "network.connectionError": "Serwer nie jest dostępny",
  "network.networkError": "Sieć niedostępna",
  "network.serverError": "Coś poszło nie tak...",
  "network.timeoutError": "Czas połączenia został przekroczony",
  "network.unknownError": "Nieznany błąd",
  "providerHints.ambientWeatherApiKey": "Utworzony w ustawieniach Twojego konta ambientweather.net.",
  "providerHints.davisApiSecret": "Wyświetlany tylko raz przy tworzeniu klucza API V2 — przechowuj go bezpiecznie.",
  "providerHints.davisV2ApiKey": "Ze strony kluczy API V2 na weatherlink.com.",
  "providerHints.ecowittApi": "Ze strony API Twojego konta Ecowitt.",
  "providerHints.ecowittApp": "Klucz aplikacji, również z Twojego konta Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Użyj e-maila i hasła konta My AcuRite — nie loginu SmartMixin.",
  "providerHints.myAcuriteEmail": "E-mail Twojego konta My AcuRite — nie login SmartMixin.",
  "providerHints.myAcuritePassword": "Hasło Twojego konta My AcuRite.",
  "providerHints.weatherflowToken": "Token do użytku osobistego z tempestwx.com → ustawienia → autoryzacje danych.",
  "providerHints.wundergroundEditKey": "Użyj innego klucza",
  "providerHints.wundergroundKey": "Długi ciąg znaków ze strony kluczy API Twojego konta Weather Underground — nie Twoje hasło do wunderground.com.",
  "providerHints.wundergroundKeyExample": "np. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "Klucz API zweryfikowany",
  "providerHints.wundergroundKeyVerifying": "Weryfikacja klucza…",
  "providerHints.wundergroundNoStationsNearby": "Nie znaleziono stacji w pobliżu tej lokalizacji. Spróbuj wprowadzić ID stacji bezpośrednio.",
  "providerHints.wundergroundStationId": "Dowolny identyfikator stacji Weather Underground — Twojej lub publicznej stacji w pobliżu.",
  "providerHints.wundergroundStationIdExample": "np. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Uzyskaj swój klucz API Ambient Weather.",
  "providerIntro.davisStep2": "Uzyskaj swój klucz API V2 i sekret API Davis.",
  "providerIntro.ecowittStep2": "Uzyskaj swój klucz API i klucz aplikacji Ecowitt.",
  "providerIntro.getStarted": "Rozpocznij",
  "providerIntro.myAcuriteStep2": "Użyj e-maila i hasła istniejącego konta My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "Zaloguj się do Netatmo gdy zostaniesz poproszony — klucz API nie jest potrzebny.",
  "providerIntro.netatmoWeatherStep2": "Zaloguj się do Netatmo gdy zostaniesz poproszony — klucz API nie jest potrzebny.",
  "providerIntro.signupBanner": "Prawie gotowe — utwórz darmowe konto SmartMixin, aby połączyć {provider}.",
  "providerIntro.step1": "Zaloguj się do konta SmartMixin (NIE do {provider}).",
  "providerIntro.step3EmailPassword": "Wprowadź je tutaj.",
  "providerIntro.step3KeyOrToken": "Wklej tutaj.",
  "providerIntro.step3OAuth": "Autoryzuj SmartMixin w wyskakującym okienku.",
  "providerIntro.step3Wunderground": "Wklej swój klucz API, a następnie wybierz stację w pobliżu lub wprowadź dowolny identyfikator stacji.",
  "providerIntro.title": "Połącz {provider}",
  "providerIntro.weatherflowStep2": "Uzyskaj swój token Tempest do użytku osobistego.",
  "providerIntro.wundergroundBrowsePublic": "Nie masz stacji? Przejrzyj publiczne",
  "providerIntro.wundergroundFindNearby": "Znajdź stacje w pobliżu",
  "providerIntro.wundergroundOrEnterId": "Lub wprowadź ID stacji",
  "providerIntro.wundergroundStep2": "Uzyskaj swój klucz API Weather Underground. Następnie będziesz mógł połączyć dowolną stację — swoją lub publiczną.",
  "reports.agroMeteorology": "Agrometeorologia",
  "reports.analysis": "Analiza",
  "reports.annualCumulativeRainfallComparison": "Porównanie rocznych skumulowanych opadów",
  "reports.annualHeatingDurationComparison": "Porównanie rocznego nasłonecznienia",
  "reports.annualHeatingEfficiency": "Roczna skuteczność nasłonecznienia",
  "reports.annualIndoorComparison": "Roczne porównanie pomiarów wewnątrz",
  "reports.annualIndoorReport": "Raport rocznych pomiarów wewnątrz",
  "reports.annualOutdoorComparison": "Roczne porównanie pomiarów zewnątrz",
  "reports.annualOutdoorReport": "Roczny raport pomiarów zewnętrznych",
  "reports.annualReport": "Raport roczny",
  "reports.annualSolarReport": "Roczny raport nasłonecznienia",
  "reports.annualWaterBalance": "Roczny bilans opadów",
  "reports.annualWaterBalanceCarryOver": "Przenieś z poprzedniego roku",
  "reports.annualWaterBalanceDescription": "Bilans wodny (wersja uproszczona, wykorzystuje się tylko deszcz i ewapotranspirację) umożliwia zarządzanie zasobami wodnymi",
  "reports.avgHumidity": "Średnia wilgotność",
  "reports.avgMaxTemperature": "Średnia T°maks",
  "reports.avgMetric": "Średnia – {metric}",
  "reports.avgMinTemperature": "Średnia T°min",
  "reports.avgPressure": "Średnie ciśnienie",
  "reports.avgTemperature": "Średnia temperatura",
  "reports.climateNormalPeriodOfRecord": "Okres pomiarowy ({years, plural, one {# rok} few {# lata} many {# lat} other {# roku}})",
  "reports.climateNormals": "Normy klimatyczne",
  "reports.climateNormalStandardLabel": "Norma standardowa ({period})",
  "reports.climateTrendPerDecade": "Trend temperatury: {value} na dziesięciolecie w ciągu {years, plural, one {# roku} few {# lat} many {# lat} other {# lat}}",
  "reports.coldestMonthRanking": "Najzimniejszy {month} w historii pomiarów",
  "reports.comfortable": "Komfortowe (45% {lessThan} Wilgotność ≤ 60%)",
  "reports.cumulativeRainfall": "Skumulowane opady",
  "reports.cumulativeRainfallDescription": "Śledź łączne opady kumulujące się w wybranym okresie.",
  "reports.dailyMaxRainfall": "Maksymalne dzienne opady",
  "reports.dataExport": "Eksport danych",
  "reports.dataExportXlsxFormatDescription": "Wyeksportuj wszystkie dane swojej stacji w formacie Excel (* .xlsx). Po kliknięciu przycisku otrzymasz wiadomość e-mail z przetworzonymi danymi po kilku minutach.",
  "reports.daysOfData": "{days, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}} danych",
  "reports.daysWithFrost": "Dni z mrozem (T°min < 0°C)",
  "reports.daysWithHeavyRain": "Dni z silnym opadem (≥ {threshold})",
  "reports.daysWithoutThaw": "Dni bez odwilży (T°max < 0°C)",
  "reports.daysWithStrongFrost": "Dni silne mrozy (T°min < -5°C)",
  "reports.emailSent": "E-mail został wysłany do Ciebie",
  "reports.frostDays": "Dni przymrozkowe",
  "reports.grasslandTemperatureSum": "Suma temperatur użytków zielonych",
  "reports.grasslandTemperatureSumDescription": "Zrównoważona odbudowa roślinności, gdy suma osiągnie {threshold}",
  "reports.growingDegreeDays": "Stopniodni wzrostu",
  "reports.highPressure": "Anticyklon (ciśnienie średnie ≥ 1013 mbar)",
  "reports.iceDays": "Dni mroźne",
  "reports.indoorReport": "Raport wewnętrzny",
  "reports.keyFacts": "Kluczowe fakty",
  "reports.longestDrySpell": "Najdłuższy okres bezopadowy",
  "reports.longestRunOfRainyDays": "Najdłuższy czas deszczowy",
  "reports.longestRunWithoutRun": "Najdłuższy czas bez deszczowy",
  "reports.longestWetSpell": "Najdłuższy okres opadowy",
  "reports.lowPressure": "Niskie ciśnienie (ciśnienie średnie {lessThan} 1013 mbar)",
  "reports.maxHumidity": "Maksymalna wilgotność",
  "reports.maxMetric": "Maksimum – {metric}",
  "reports.maxPressure": "Maksymalne ciśnienie",
  "reports.maxPressureMagnitude24h": "Maksymalna wielkość (/24H)",
  "reports.maxTemperature": "Maksymalna temperatura",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maksymalna wielkość (/24 godz.)",
  "reports.minHumidity": "Minimalna wilgotność",
  "reports.minMetric": "Minimum – {metric}",
  "reports.minPressure": "Minimalne ciśnienie",
  "reports.minPressureMagnitude24h": "Minimalna wielkość (/24H)",
  "reports.minTemperature": "Minimalna temperatura",
  "reports.minTempMagnitude24h": "Minimalna wielkość (/24 godz.)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Jeszcze # dzień} few {Jeszcze # dni} many {Jeszcze # dni} other {Jeszcze # dnia}} w tym miesiącu",
  "reports.monthlyAverageCountdownDetail": "Wtedy pojawią się średnia miesiąca i jej ranking.",
  "reports.monthlyAverageRule": "Średnie miesięczne i rankingi pojawiają się, gdy miesiąc kalendarzowy ma zarejestrowane {days, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}}.",
  "reports.monthlyHeatingEfficiency": "Miesięczna wydajność grzewcza",
  "reports.monthlyIndoorReport": "Miesięczny raport wewnętrzny",
  "reports.monthlyOutdoorReport": "Miesięczny raport zewnętrzny",
  "reports.monthlyReport": "Miesięczny raport",
  "reports.monthlySolarReport": "Miesięczny raport nasłonecznienia",
  "reports.monthlyWindReport": "Miesięczny raport z wiatru",
  "reports.monthsOfData": "{months, plural, one {# miesiąc} few {# miesiące} many {# miesięcy} other {# miesiąca}} danych",
  "reports.numberOfDays": "Liczba dni",
  "reports.onThisDayInHistory": "Tego dnia w historii",
  "reports.outdoorReport": "Raport zewnętrzny",
  "reports.overviewSection": "Przegląd",
  "reports.rainfall": "Deszcz",
  "reports.rainyDays": "Deszczowe dni",
  "reports.recordDailyRain": "Najwyższy opad dobowy",
  "reports.recordHigh": "Rekord ciepła",
  "reports.recordLow": "Rekord zimna",
  "reports.recordsAndClimatology": "Rekordy i klimat",
  "reports.recordsSince": "Rekordy od {date}",
  "reports.recordWindGust": "Najsilniejszy poryw wiatru",
  "reports.relativelyWet": "Zbyt mokre (60 % {lessThan} Wilgotność ≤ 80 %)",
  "reports.sectionReportCount": "{count, plural, one {# raport} few {# raporty} many {# raportów} other {# raportów}}",
  "reports.sendEmail": "Wyślij e-mail",
  "reports.summerDays": "Dni letnie",
  "reports.tooDry": "Zbyt suche (wilgotność ≤ 45%)",
  "reports.tooWet": "Bardzo mokre (Wilgotność {greaterThan} 80%)",
  "reports.tropicalNights": "Tropikalne noce (T° min ≥ 20° C)",
  "reports.unlockPremiumSubtitle": "Zawarte w SmartMixin Premium",
  "reports.unlockPremiumTitle": "Odblokuj {count, plural, one {# funkcję premium} few {# funkcje premium} many {# funkcji premium} other {# funkcji premium}}",
  "reports.warmestMonthRanking": "Najcieplejszy {month} w historii pomiarów",
  "reports.waterBalance": "Bilans wodny",
  "reports.yearsOfData": "{years, plural, one {# rok} few {# lata} many {# lat} other {# roku}} danych",
  "reports.yearToDateTemperatureComparison": "Porównanie temperatur od początku roku",
  "sensors.aqiByChannel": "AQI wg kanału",
  "sensors.bgtSensors": "Czarna kula & WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareAqi": "Porównaj AQI",
  "sensors.compareHumidity": "Porównaj wilgotność",
  "sensors.compareMoisture": "Porównaj wilgotność gleby",
  "sensors.comparePm25": "Porównaj PM2.5",
  "sensors.compareTemperatures": "Porównaj temperatury",
  "sensors.depthByChannel": "Głębokość wg kanału",
  "sensors.heatStressExtreme": "Ekstremalny stres cieplny",
  "sensors.heatStressModerate": "Umiarkowany stres cieplny",
  "sensors.heatStressNone": "Brak stresu cieplnego",
  "sensors.heatStressStrong": "Silny stres cieplny",
  "sensors.heatStressVeryStrong": "Bardzo silny stres cieplny",
  "sensors.humidityByChannel": "Wilgotność wg kanału",
  "sensors.indoorAirQuality": "Jakość powietrza wewnątrz",
  "sensors.indoorAirQualityPm": "PM2.5 i PM10 AQI",
  "sensors.indoorClimate": "Klimat wewnętrzny",
  "sensors.indoorCo2Levels": "Poziomy CO2",
  "sensors.indoorTemperatureAndHumidity": "Temperatura i wilgotność",
  "sensors.last24Hours": "24 godziny",
  "sensors.last30Days": "30 dni",
  "sensors.last7Days": "7 dni",
  "sensors.leafTemperatureByChannel": "Temperatura liści wg kanału",
  "sensors.leafWetnessByChannel": "Wilgotność liści wg kanału",
  "sensors.lightningSensor": "Błyskawica",
  "sensors.moistureByChannel": "Wilgotność gleby wg kanału",
  "sensors.noDataAvailable": "Brak dostępnych danych",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 wg kanału",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Wybierz kanał",
  "sensors.sensorDetailDescription": "Przeglądaj dane historyczne i trendy dla kanałów czujnika.",
  "sensors.sensorHistory": "Historia czujnika",
  "sensors.soilConductivityByChannel": "Przewodność wg kanału",
  "sensors.soilTemperatureByChannel": "Temperatura gleby wg kanału",
  "sensors.strikesToday": "Uderzenia dzisiaj",
  "sensors.temperatureByChannel": "Temperatura wg kanału",
  "sensors.viewChart": "Zobacz wykres",
  "settings.about": "Informacje",
  "settings.aboutDescription": "Umowa licencyjna, polityka prywatności",
  "settings.account": "Konto",
  "settings.accountDescription": "Profil, zmiana hasła",
  "settings.accountIntro": "Dane dotyczą Twojego konta:",
  "settings.accountOnHoldTitle": "Konto wstrzymane",
  "settings.accountSection": "Konto",
  "settings.appearance": "Wygląd",
  "settings.appearanceDescription": "Motyw i opcje wyświetlania",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arabski",
  "settings.availableServices": "Dostępne",
  "settings.bulgarian": "bułgarski",
  "settings.cannotDisconnectLastAccount": "Nie można odłączyć jedynej metody logowania. Najpierw dodaj inną metodę logowania.",
  "settings.catalan": "kataloński",
  "settings.changeEmail": "Zmień e-mail",
  "settings.changePassword": "Zmień hasło",
  "settings.chartGestures": "Gesty na wykresach",
  "settings.chartGesturesDescription": "Przesuwanie palcem po wykresach zmienia przedział czasu, szczypanie wykresów zmienia skalę czasu",
  "settings.choiceCount": "{count, plural, one {Dostępny: #} few {Dostępne: #} many {Dostępnych: #} other {Dostępnych: #}}",
  "settings.connect": "Połącz",
  "settings.connected": "Połączono",
  "settings.connectedAccounts": "Połączone konta",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Połączone",
  "settings.connectedSince": "Połączono od {date}",
  "settings.connectionSection": "Połączenie",
  "settings.connectionSuccess": "Konto {provider} połączone pomyślnie",
  "settings.contactUs": "Kontakt",
  "settings.contactUsDescription": "Uzyskaj pomoc lub wyślij opinię",
  "settings.croatian": "chorwacki",
  "settings.currentPassword": "Aktualne hasło",
  "settings.czech": "czeski",
  "settings.dailyDetailByPeriods": "Szczegóły dnia według pór dnia",
  "settings.dailyDetailByPeriodsDescription": "Grupuj 24 godziny na noc, rano, popołudnie i wieczór — ten sam podział, którego używa podsumowanie dnia.",
  "settings.dangerZone": "Strefa ryzyka",
  "settings.danish": "duński",
  "settings.dark": "Ciemny motyw",
  "settings.dataDisplay": "Wyświetlanie danych",
  "settings.dateAndTime": "Data i czas",
  "settings.disconnect": "Odłącz",
  "settings.disconnectConfirmation": "Czy na pewno chcesz odłączyć swoje konto {provider}?",
  "settings.disconnectionSuccess": "Konto {provider} odłączone pomyślnie",
  "settings.disconnectProviderDescription": "Zatrzymuje synchronizację. Twoja historia zostaje zachowana.",
  "settings.donateButton": "Przekaż darowiznę",
  "settings.donateDescription": "SmartMixin tworzy mały zespół. Jeśli aplikacja jest dla Ciebie przydatna, możesz wesprzeć jej rozwój jednorazową darowizną w dowolnej kwocie. To prezent — nie zmienia Twojego planu ani nie odblokowuje żadnych funkcji.",
  "settings.donateSuccessBody": "Twoja darowizna pomaga utrzymać działanie SmartMixin i go ulepszać. Bardzo to doceniamy.",
  "settings.donateSuccessTitle": "Dziękujemy za wsparcie!",
  "settings.donateTitle": "Wesprzyj SmartMixin",
  "settings.dragToReorder": "Przeciągnij, aby zmienić kolejność",
  "settings.dutch": "holenderski",
  "settings.emailChange": "Zmień adres e-mail",
  "settings.emailChangeConfirmation": "Potwierdzenie zmiany e-maila",
  "settings.emailChangeFailure": "Link do zmiany e-maila jest nieprawidłowy lub wygasł.",
  "settings.emailChangeSuccess": "Twój e-mail został pomyślnie zmieniony na {newEmail}.",
  "settings.emailChangeVerificationSent": "E-mail weryfikacyjny został wysłany na Twój nowy adres e-mail. Sprawdź swoją skrzynkę odbiorczą i kliknij link, aby potwierdzić zmianę.",
  "settings.english": "angielski",
  "settings.forecastModelOrderEmpty": "Brak zapisanej kolejności — używamy domyślnie GFS.",
  "settings.forecastModelOrderFreeHint": "Modele premium wymagają subskrypcji SmartMixin Premium.",
  "settings.forecastModelOrderHelp": "Wybieramy pierwszy model z listy, który obejmuje daną stację.",
  "settings.forecastModelOrderReset": "Przywróć domyślne",
  "settings.forecastModelOrderTitle": "Domyślny model prognozy",
  "settings.forecastModels": "Modele prognozy",
  "settings.forecastModelsDescription": "Posortuj według preferencji",
  "settings.french": "francuski",
  "settings.german": "niemiecki",
  "settings.gestures": "Gesty",
  "settings.greek": "grecki",
  "settings.helpCenter": "Centrum pomocy",
  "settings.helpCenterDescription": "Najczęściej zadawane pytania i poradniki",
  "settings.hungarian": "węgierski",
  "settings.integrationsSection": "Integracje",
  "settings.italian": "włoski",
  "settings.japanese": "język japoński",
  "settings.korean": "koreański",
  "settings.language": "Język",
  "settings.languageDescription": "Preferowany język",
  "settings.light": "Jasny motyw",
  "settings.measurementUnits": "Jednostki miary",
  "settings.modelOrderSection": "Kolejność modeli",
  "settings.newEmailAddress": "Nowy adres e-mail",
  "settings.newPassword": "Nowe hasło",
  "settings.newPasswordAgain": "Powtórz nowe (hasło)",
  "settings.norwegian": "norweski",
  "settings.notConnected": "Niepołączono",
  "settings.notificationsSection": "Powiadomienia",
  "settings.oldPassword": "Stare hasło",
  "settings.ongoingNotificationEnabled": "Włącz stałe powiadomienie",
  "settings.ongoingNotificationMetrics": "Wyświetlane wskaźniki",
  "settings.ongoingNotificationPermissionRequired": "Wymagane uprawnienie do powiadomień",
  "settings.ongoingNotificationPreviewHint": "Podgląd — włącz widget, aby go pokazać",
  "settings.ongoingNotificationStation": "Stacja pogodowa",
  "settings.ongoingNotificationStatusBar": "Pasek stanu",
  "settings.passwordChange": "Zmiana hasła",
  "settings.passwordChangeDescription": "Zadbaj o bezpieczeństwo konta",
  "settings.polish": "polski",
  "settings.portuguese": "portugalski",
  "settings.preferencesSection": "Preferencje",
  "settings.premium": "Premium",
  "settings.premiumActive": "Aktywny",
  "settings.premiumAnnualThenPrice": "Następnie 9,99 €/rok",
  "settings.premiumAnnualTrialInfo": "Zacznij od bezpłatnego okresu próbnego na {days} dni",
  "settings.premiumCurrentPlan": "Aktualny plan",
  "settings.premiumDescription": "Odblokuj płatne funkcje",
  "settings.premiumDownloadApp": "Pobierz aplikację, aby się zasubskrybować:",
  "settings.premiumExpiresOn": "Odnawia się {date}",
  "settings.premiumFreePlan": "Bezpłatny",
  "settings.premiumInactive": "Brak subskrypcji",
  "settings.premiumManageWebSubscription": "Zarządzaj subskrypcją, zaktualizuj metodę płatności lub anuluj.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Rocznie — 9,99 €/rok",
  "settings.premiumSubscribedOn": "Subskrypcja na {platform}",
  "settings.premiumSubscribeMonthly": "Miesięcznie — 1,99 €/miesiąc",
  "settings.premiumSubscribeOnWeb": "Subskrybuj teraz, aby odblokować wszystkie funkcje premium.",
  "settings.premiumSubscriptionSuccess": "Twoja subskrypcja została aktywowana! Korzystaj ze wszystkich funkcji premium.",
  "settings.premiumSubscriptionSuccessTitle": "Witamy w Premium!",
  "settings.premiumWebappNotice": "Subskrypcje można kupić tylko przez aplikację mobilną SmartMixin na iOS lub Android.",
  "settings.privacyPolicy": "Polityka prywatności",
  "settings.profile": "Profil",
  "settings.russian": "rosyjski",
  "settings.serbian": "serbski",
  "settings.settings": "Ustawienia",
  "settings.signedInAs": "Zalogowano jako",
  "settings.slovak": "słowacki",
  "settings.smallDecimals": "Małe miejsca dziesiętne",
  "settings.smallDecimalsDescription": "Wyświetlaj cyfry dziesiętne w mniejszym rozmiarze",
  "settings.socialConnectionsIntro": "Połącz swoje konta społecznościowe, aby szybko się logować. Możesz połączyć lub odłączyć konta w dowolnym momencie.",
  "settings.spanish": "hiszpański",
  "settings.statusBarWidget": "Widget paska stanu",
  "settings.statusBarWidgetDescription": "Zawsze widoczne dane pogodowe",
  "settings.subscriptionSection": "Subskrypcja",
  "settings.supportSection": "Wsparcie",
  "settings.swedish": "szwedzki",
  "settings.systemTheme": "Motyw systemowy",
  "settings.termsOfService": "Warunki usługi",
  "settings.turkish": "turecki",
  "settings.ukrainian": "ukraiński",
  "settings.units": "Jednostki",
  "settings.unitsDescription": "Jednostki miary wyświetlane w aplikacji",
  "settings.update": "Aktualizacja",
  "settings.updateYourProfile": "Zaktualizuj swój profil",
  "settings.updateYourProfileDescription": "Imię i preferencje wyświetlania",
  "settings.weatherServices": "Usługi pogodowe",
  "settings.weatherServicesConnected": "{count, plural, =0 {Brak połączonych usług} one {# połączona usługa} few {# połączone usługi} many {# połączonych usług} other {# połączonych usług}}",
  "settings.weatherServicesDescription": "Połącz Netatmo, Davis, Weatherflow i inne",
  "settings.windDirectionConvention": "Strzałka kierunku wiatru",
  "settings.windDirectionConventionDescription": "Wybierz sposób wyświetlania strzałek kierunku wiatru",
  "settings.windDirectionMeteorological": "Kierunek pochodzenia",
  "settings.windDirectionMeteorologicalDescription": "Strzałka wskazuje skąd wieje wiatr (konwencja meteorologiczna)",
  "settings.windDirectionOceanographic": "Kierunek przepływu",
  "settings.windDirectionOceanographicDescription": "Strzałka wskazuje dokąd wieje wiatr (konwencja oceanograficzna)",
  "units.absolutePressure": "Ciśnienie absolutne",
  "units.airDensity": "Gęstość powietrza",
  "units.airGap": "Szczelina powietrzna",
  "units.apparentTemperature": "Temperatura odczuwalna",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Średnia",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Temp. czarnej kuli",
  "units.boilerOn": "Bojler Włączony",
  "units.co2": "CO2",
  "units.conductivity": "Przewodność",
  "units.coolingDegreeDays": "Dni chłodne",
  "units.dailyHeatingDuration": "Dzienna długość nasłonecznienia",
  "units.dailyPrecipitation": "Opady dobowe",
  "units.dailyRain": "Dzienny opad",
  "units.degreeDay": "Stopień-dzień",
  "units.degreeDayShort": "DJU",
  "units.depth": "Głębokość",
  "units.depthSensors": "Czujniki głębokości",
  "units.dewPoint": "Punkt rosy",
  "units.distance": "Odległość",
  "units.downTrend": "w dół",
  "units.E": "E",
  "units.E_long": "Wschód",
  "units.ENE": "ENE",
  "units.ENE_long": "Wschód-północny wschód",
  "units.ESE": "ESE",
  "units.ESE_long": "Wschód-południowy wschód",
  "units.ET": "ewapotranspiracja",
  "units.ETshort": "I",
  "units.feelLike": "Odczuwalna",
  "units.feelsLike": "Odczuwalna",
  "units.footMile": "Stopy,mile",
  "units.frostPoint": "punkt zamarzania",
  "units.gust": "Porywy",
  "units.heatIndex": "Indeks ciepła",
  "units.heatingDegreeDays": "Stopniodni ogrzewania",
  "units.heatingPower": "Moc grzewcza",
  "units.humidex": "Humidex",
  "units.humidity": "Wilgotność",
  "units.inch": "cale",
  "units.inchOfMercury": "cal rtęci",
  "units.kilometerPerHour": "Kilometry na godzinę",
  "units.knot": "Knot",
  "units.last12Hours": "Ostatnie 12 godzin",
  "units.last24Hours": "Ostatnie 24 godziny",
  "units.last3Hours": "Ostatnie 3 godziny",
  "units.last6Hours": "Ostatnie 6 godzin",
  "units.lastHour": "Ostatnia godzina",
  "units.lastLightningImpact": "Ostatnie uderzenie",
  "units.lastMeasure": "Ostatni pomiar",
  "units.leafSensors": "Czujniki wilgotności",
  "units.leafWetness": "Wilgotność liści",
  "units.lightningDistance": "Odległość",
  "units.lightningStrikeCount": "Liczba uderzeń pioruna",
  "units.lightningStrikeDistance": "Dystans uderzenia pioruna",
  "units.max": "Max.",
  "units.max_gust": "Max. poryw",
  "units.max_wind": "Max. wiatr",
  "units.meterKilometer": "Metr, kilometr",
  "units.meterPerSecond": "Metr na sekundę",
  "units.milePerHour": "Mile na godzinę",
  "units.millibar": "Millibar",
  "units.millimeter": "Milimetr",
  "units.millimeterOfMercury": "Milimetr rtęci",
  "units.min": "Min.",
  "units.N": "N",
  "units.N_long": "Północ",
  "units.NE": "NE",
  "units.NE_long": "Północny wschód",
  "units.NNE": "NNE",
  "units.NNE_long": "Północno-północno wschodni",
  "units.NNW": "NNW",
  "units.NNW_long": "Północno-północno zachodni",
  "units.noise": "Hałas",
  "units.normalizedHeatingCoefficient": "Znormalizowany współczynnik ciepła",
  "units.NW": "NW",
  "units.NW_long": "północny zachód",
  "units.O3": "Ozon",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM 2,5",
  "units.precipitation": "Opady",
  "units.pressure": "Ciśnienie",
  "units.rain": "Deszcz",
  "units.rainRate": "Natężenie deszczu",
  "units.referenceTemperature": "Temperatura odniesienia",
  "units.relativePressure": "Ciśnienie względne",
  "units.S": "S",
  "units.S_long": "Południe",
  "units.SE": "SE",
  "units.SE_long": "Południowo-wschodni",
  "units.setPoint": "Wartość zadana",
  "units.snow": "Śnieg",
  "units.snowfall": "Opady śniegu",
  "units.soilMoisture": "Wilgotność",
  "units.soilSensors": "Czujniki gleby",
  "units.solarEnergy": "Energia słoneczna",
  "units.solarRadiation": "Nasłonecznienie",
  "units.speed": "Prędkość",
  "units.SSE": "SSE",
  "units.SSE_long": "Południowy-południowo wschodni",
  "units.SSW": "SSW",
  "units.SSW_long": "Południowy-południowy zachodni",
  "units.stableTrend": "stabilność",
  "units.sum": "Suma",
  "units.SW": "SW",
  "units.SW_long": "Południowy zachód",
  "units.temperature": "Temperatura",
  "units.temperatureAndHumiditySensors": "Czujniki temperatury i wilgotności",
  "units.temperatureSensors": "Czujniki temperatury i wilgotności",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Dzisiaj",
  "units.upTrend": "góra",
  "units.uv": "UV",
  "units.visibility": "Widoczność",
  "units.W": "W",
  "units.W_long": "Zachód",
  "units.wetBulbGlobeTemperature": "Temp. mokrego termometru",
  "units.wetBulbTemperature": "Temp. mokra żarówka",
  "units.wind": "Wiatr",
  "units.windChill": "Chłód wiatru",
  "units.windDirection": "Kierunek wiatru",
  "units.windRun": "przebieg wiatru",
  "units.windRunDescription": "Droga wiatru to całkowita odległość przebyta przez wiatr w określonym czasie",
  "units.WNW": "WNW",
  "units.WNW_long": "Zachód-północny zachód",
  "units.WSW": "WSW",
  "units.WSW_long": "Zachód-południowy zachód"
}
